/**
 *
 *
 *
 */
import React from 'react';
import styled from 'styled-components';


/**
 *
 *
 *
 */
export function Mic(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="black" strokeWidth="1.0" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.19531 14.9548H10.1968" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12.1966 7.45349V8.45371C12.1966 10.6542 10.3962 12.4546 8.19569 12.4546C5.99522 12.4546 4.19482 10.6542 4.19482 8.45371V7.45349" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.19629 12.4541V14.9565" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.19577 2.95187C7.9327 2.95054 7.67198 3.00138 7.42867 3.10144C7.18537 3.20151 6.96432 3.34881 6.7783 3.53483C6.59227 3.72085 6.44497 3.9419 6.34491 4.18521C6.24485 4.42851 6.19401 4.68923 6.19534 4.9523V8.42181C6.19534 9.52205 7.10179 10.4535 8.19577 10.4535C9.28976 10.4535 10.1962 9.54706 10.1962 8.42181V4.9523C10.1962 3.82706 9.32102 2.95187 8.19577 2.95187Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Pi(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1_20899)">
        <path d="M7 8H17" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 8L9 16" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 8L15 14.03C15 15.118 15.882 16 16.97 16L17 16" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1_20899">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Brain(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="19" cy="6" r="2" stroke="#000" strokeLinejoin="round" />
      <circle cx="19" cy="18" r="2" stroke="#000" strokeLinejoin="round" />
      <circle cx="19" cy="12" r="2" stroke="#000" strokeLinejoin="round" />
      <path d="M7 16.5714C7 18.5266 8.62599 19.3668 10.0235 19.7279C11.0929 20.0042 12 19.1046 12 18V6C12 4.89543 11.0857 4.00026 10.0403 4.35703C8.63907 4.83526 7 5.95406 7 8.57143" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 8C5.34315 8 4 9.79086 4 12C4 14.2091 5.34315 16 7 16C7.76835 16 8.46924 15.6149 9 14.9815" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17 16.5L14.5 14.5M17 12H14.5" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 9.5L17 7.5" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Reader(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="black" strokeWidth="1.0" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinejoin="round" d="M11.7687 2.33154H4.76717C3.93856 2.33154 3.26685 3.00326 3.26685 3.83187V13.834C3.26685 14.6627 3.93856 15.3344 4.76717 15.3344H11.7687C12.5973 15.3344 13.269 14.6627 13.269 13.834V3.83187C13.269 3.00326 12.5973 2.33154 11.7687 2.33154Z" />
      <path strokeLinejoin="round" d="M5.76733 4.8324H10.7691" />
      <path strokeLinejoin="round" d="M5.76733 7.33325H10.7691" />
      <path strokeLinejoin="round" d="M5.76733 9.83411H8.26972" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function AWS(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M5.0588 10.2887L3.54473 10.9389L4.9471 11.5385L6.57286 10.9389L5.0588 10.2887ZM2.78266 11.1015L2.73192 14.0279L4.9471 15.0034V11.9652L2.78266 11.1015V11.1015ZM7.33494 11.1015L5.33305 11.8637V14.7291L7.33494 13.9162V11.1015ZM9.72277 1.99707L8.19862 2.64732L9.61108 3.24697L11.2368 2.64732L9.72277 1.99707V1.99707ZM7.6092 2.86075V5.78714L9.49925 6.33592L9.56021 3.67356L7.6092 2.86075V2.86075ZM11.8364 3.02331L10.0479 3.78539V6.66105L11.8364 5.8481V3.02331V3.02331ZM2.56418 6.11585L1.05025 6.76623L2.45248 7.36575L4.07824 6.76623L2.56418 6.11585V6.11585ZM0.288039 6.9288L0.237305 9.85519L2.45248 10.8307V7.79248L0.288039 6.9288ZM4.84019 6.9288L2.83857 7.69087V10.5562L4.84019 9.74336V6.9288ZM7.44159 6.00748L5.92752 6.65786L7.32976 7.25737L8.95552 6.65786L7.44159 6.00748ZM5.16558 6.82042L5.11471 9.74695L7.32989 10.7225V7.6841L5.16558 6.82042V6.82042ZM9.71773 6.82042L7.71598 7.5825V10.4481L9.71773 9.63512V6.82042V6.82042ZM14.4868 1.99707L12.9728 2.64732L14.3752 3.24697L16.001 2.64732L14.4868 1.99707ZM12.2107 2.81002L12.16 5.73641L14.3752 6.71178V3.67356L12.2107 2.81002V2.81002ZM16.7629 2.81002L14.7613 3.57209V6.43752L16.7629 5.62471V2.81002V2.81002Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Anaconda(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M7.87587 16.9473C6.38757 16.8045 5.0532 16.3625 3.98605 15.659L3.76187 15.5112L3.70795 15.0951C3.64818 14.6318 3.58549 13.8951 3.58602 13.6527V13.4947L4.28223 13.489C4.66512 13.4858 5.09464 13.4713 5.23688 13.4558C5.46253 13.4319 5.50716 13.436 5.5891 13.4874C6.34813 13.9636 7.50758 14.2796 8.49384 14.2785C10.0742 14.2775 11.4707 13.6948 12.598 12.5666C13.0966 12.0673 13.3706 11.6923 13.6698 11.0977C14.4917 9.46766 14.5093 7.60258 13.7192 5.97098C12.937 4.35598 11.4116 3.16943 9.66844 2.8208C9.21913 2.73048 8.60023 2.6828 8.23034 2.70923L7.92886 2.73115L8.00509 2.62317C8.04759 2.56407 8.3273 2.26458 8.62719 1.95805L9.17252 1.4009L8.94833 1.19238C8.63131 0.89661 8.19342 0.531375 7.86511 0.288063L7.58395 0.0800785L7.68966 0.0551097C7.89884 0.00583628 9.11952 0.0208441 9.55634 0.0779535C13.1455 0.546914 16.0102 3.15389 16.788 6.65948C17.0426 7.80552 17.0478 9.07494 16.8035 10.261C16.4947 11.7577 15.7098 13.2337 14.6198 14.3662C13.2065 15.8337 11.3131 16.7448 9.28448 16.9337C8.9462 16.9653 8.14309 16.9726 7.876 16.9473H7.87587ZM2.56509 14.511C2.08405 14.0306 1.43406 13.2503 1.47816 13.2062C1.48639 13.1978 1.66808 13.2269 1.88124 13.27C2.20504 13.3358 2.93338 13.4463 3.04335 13.4463C3.05995 13.4463 3.0739 13.5838 3.07443 13.7587C3.07496 14.045 3.10498 14.4554 3.15651 14.8792C3.17098 14.9986 3.1658 15.0474 3.13924 15.0474C3.11852 15.0474 2.85967 14.8061 2.56509 14.5108V14.511ZM3.58602 12.7947C3.58602 12.537 3.65296 11.769 3.6778 11.7421C3.68975 11.7296 3.79095 11.8401 3.90305 11.988C4.01461 12.1364 4.26775 12.417 4.46537 12.6116L4.82437 12.9665H3.58602V12.7947ZM2.92927 12.9126C2.39377 12.8467 1.3063 12.6376 1.21984 12.5841C1.19327 12.5675 1.22502 12.4388 1.3314 12.1312C1.47191 11.7265 1.80341 10.9313 1.85534 10.8757C1.86823 10.8622 2.04314 10.9364 2.24395 11.0412C2.44516 11.146 2.73669 11.2861 2.89287 11.3535L3.17616 11.4749L3.15651 11.6212C3.11135 11.9625 3.07496 12.4243 3.07443 12.6702C3.07403 12.8155 3.06248 12.9322 3.04959 12.9297C3.03605 12.927 2.98212 12.9192 2.92927 12.9124V12.9126ZM0.601328 11.5352C0.426584 11.0753 0.289686 10.6019 0.192 10.1198C0.0930547 9.62903 0.0961094 9.62545 0.40118 9.8661C0.542227 9.97766 0.8125 10.1742 1.00149 10.3024C1.19009 10.4312 1.34481 10.5416 1.34481 10.5473C1.34481 10.5535 1.28571 10.6864 1.21359 10.842C1.11647 11.0569 1.02458 11.2742 0.938008 11.4936C0.858719 11.6959 0.783414 11.8734 0.77 11.8874C0.756984 11.9013 0.681281 11.7426 0.601328 11.5352V11.5352ZM2.9043 10.7071C2.65846 10.594 2.21234 10.3663 2.15152 10.3232C2.13903 10.3143 2.46801 9.7722 2.63562 9.52584L2.76684 9.33233L2.78968 9.42875C2.93644 10.043 3.02476 10.3554 3.116 10.5826C3.17577 10.7314 3.22291 10.8529 3.22132 10.8529C3.2192 10.8524 3.07655 10.787 2.9043 10.7071ZM1.2286 9.74591C0.883023 9.50459 0.305555 9.05023 0.269297 8.99153C0.235164 8.93601 1.41175 7.79569 1.50352 7.79569C1.51866 7.79569 1.6463 7.94709 1.78681 8.13197C1.92799 8.31711 2.11619 8.55219 2.20597 8.65432C2.29575 8.75659 2.36933 8.8469 2.36933 8.85513C2.36933 8.86337 2.25644 9.03934 2.11778 9.24573C1.97979 9.45173 1.81948 9.70394 1.76251 9.80501C1.7054 9.90621 1.64059 9.98922 1.61774 9.98922C1.59543 9.98922 1.41998 9.87978 1.2286 9.74591V9.74591ZM0.0322266 8.21112C0.036875 7.8091 0.172344 6.89336 0.305156 6.36729C0.436906 5.84653 0.411008 5.85012 0.650203 6.3232C0.765352 6.55203 0.923531 6.84568 1.00083 6.97637L1.14148 7.21304L0.898695 7.42102C0.765352 7.53524 0.515797 7.767 0.34407 7.93567C0.172344 8.10474 0.0322266 8.22879 0.0322266 8.21112ZM2.60613 8.1058C2.35339 7.80432 2.05138 7.3857 2.06745 7.3598C2.08923 7.32447 2.4623 7.07133 2.76577 6.88566C2.96911 6.76108 2.98478 6.75643 2.96446 6.82496C2.88982 7.08062 2.78384 7.61812 2.75435 7.89012C2.73523 8.0649 2.7165 8.21166 2.71238 8.21577C2.70827 8.22002 2.66059 8.17022 2.60613 8.1058V8.1058ZM1.49529 6.50276C1.16326 5.92423 0.779828 5.0968 0.824453 5.05577C0.896172 4.98883 2.11313 4.64803 2.47266 4.59411L2.61277 4.57286L2.6833 4.99985C2.72181 5.23493 2.78649 5.5647 2.82753 5.73337L2.90177 6.04044L2.6388 6.18985C2.49404 6.27246 2.21686 6.44565 2.02335 6.57488L1.67166 6.80995L1.49529 6.50276ZM3.46158 5.17769C3.42794 4.99827 3.3966 4.81842 3.36755 4.6382L3.34059 4.45758L3.50395 4.43845C3.59426 4.42809 3.84023 4.4099 4.05087 4.39861L4.4343 4.37829L4.30295 4.51841C4.0862 4.74977 3.8397 5.06055 3.67939 5.30598L3.52838 5.53668L3.46158 5.17769ZM1.31533 4.00681C1.5342 3.63587 2.22576 2.75545 2.46017 2.54853L2.52923 2.4873V3.83296L2.249 3.88741C2.00529 3.9347 1.4844 4.0618 1.29913 4.11891C1.24255 4.13657 1.24361 4.12714 1.3152 4.00681H1.31533ZM3.27166 2.92094C3.27737 2.47947 3.29025 2.11012 3.30074 2.09976C3.3366 2.06337 4.83526 2.36166 4.89184 2.41612C4.89715 2.42143 4.85199 2.58891 4.7917 2.78919C4.731 2.99 4.65623 3.26333 4.62515 3.39667L4.56857 3.64052L4.11727 3.66044C3.86878 3.67133 3.5746 3.68992 3.46357 3.70187L3.2613 3.72366L3.27166 2.92094ZM5.4106 3.5773C5.4106 3.56269 5.5377 3.10355 5.60517 2.87525L5.66852 2.66155L6.05966 2.82239C6.57789 3.03555 6.56607 3.02785 6.45026 3.07606C6.17998 3.18975 5.7344 3.40544 5.59747 3.49004C5.45217 3.57929 5.4106 3.59855 5.4106 3.5773V3.5773ZM6.85135 2.29061C6.73673 2.2331 6.4897 2.12406 6.30244 2.04836L5.96164 1.9109L5.99484 1.81594C6.03681 1.69561 6.50577 0.75543 6.59356 0.615313L6.65944 0.510125L6.85959 0.64493C7.12162 0.822367 7.60307 1.18242 7.76178 1.32041L7.88795 1.42998L7.55327 1.81182C7.36959 2.0214 7.18338 2.23868 7.13929 2.2942L7.05934 2.39593L6.85135 2.29061ZM4.75424 1.54978C4.54709 1.49688 4.33908 1.44743 4.13029 1.40143L3.92177 1.3584L4.20387 1.19079C4.37218 1.09178 4.54313 0.997319 4.71652 0.9075C4.96289 0.783055 5.70584 0.476922 5.72191 0.492992C5.72723 0.498172 5.67012 0.62368 5.59441 0.771633C5.51911 0.919453 5.40077 1.17007 5.33184 1.32878C5.26278 1.48696 5.1985 1.62548 5.18854 1.63584C5.17871 1.64634 4.98321 1.60742 4.75424 1.54978V1.54978Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Docker(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M16.575 6.91953C16.0039 6.5875 15.2468 6.54766 14.6093 6.73359C14.5297 6.04297 14.0781 5.44531 13.5468 5.02031L13.3343 4.84766L13.1484 5.06016C12.7898 5.47187 12.6836 6.1625 12.7367 6.69375C12.7765 7.07891 12.8961 7.47734 13.1351 7.79609C12.9492 7.90234 12.75 8.04844 12.564 8.11484C12.1922 8.24766 11.7804 8.38047 11.382 8.38047H10.4922V6.50781H8.7656V3.1875H6.77341V4.78125H3.4531V6.50781H1.72653V8.36719H0.239034L0.212471 8.56641C0.146065 9.41641 0.252315 10.2398 0.610909 11.0234L0.757002 11.3156L0.770284 11.3422C1.8195 13.1219 3.65231 13.8656 5.65778 13.8656C9.53591 13.8656 12.7367 12.1258 14.1976 8.47344C15.1804 8.52656 16.1898 8.23438 16.6679 7.29141L16.7875 7.05234L16.575 6.91953V6.91953ZM3.71872 5.17969H5.04685V6.64062H3.71872V5.17969ZM5.45856 11.05C5.45856 11.2758 5.27263 11.4617 5.04685 11.4617C4.82107 11.4617 4.63513 11.2758 4.63513 11.05C4.63513 10.8242 4.82107 10.6383 5.04685 10.6383C5.27263 10.6516 5.45856 10.8242 5.45856 11.05ZM3.71872 6.90625H5.04685V8.36719H3.71872V6.90625ZM1.99216 6.90625H3.4531V8.36719H1.99216V6.90625ZM5.67107 13.5734C3.57263 13.5602 2.44372 12.8563 1.51403 11.9266C1.79294 11.9398 2.05856 11.9531 2.29763 11.9531C2.51013 11.9531 2.72263 11.9531 2.92185 11.9398C3.43981 11.9133 3.89138 11.8469 4.26325 11.7406C4.56872 12.4445 5.12653 13.0953 6.12263 13.5734H5.67107ZM6.77341 8.36719H5.31247V6.90625H6.77341V8.36719ZM6.77341 6.64062H5.31247V5.17969H6.77341V6.64062ZM8.49997 8.36719H7.03903V6.90625H8.49997V8.36719ZM8.49997 6.64062H7.03903V5.17969H8.49997V6.64062ZM8.49997 4.91406H7.03903V3.45312H8.49997V4.91406ZM10.2265 8.36719H8.7656V6.90625H10.2265V8.36719ZM5.1531 10.7844C5.12653 10.7711 5.08669 10.7578 5.04685 10.7578C4.88747 10.7578 4.75466 10.8906 4.75466 11.05C4.75466 11.2094 4.88747 11.3422 5.04685 11.3422C5.20622 11.3422 5.33903 11.2094 5.33903 11.05C5.33903 11.0102 5.32575 10.9703 5.31247 10.9438C5.28591 10.9836 5.25935 11.0102 5.20622 11.0102C5.13982 11.0102 5.08669 10.957 5.08669 10.8906C5.09997 10.8375 5.12653 10.7977 5.1531 10.7844V10.7844Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function FastAPI(props) {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M7.54548 17.9449C7.29273 17.9148 7.02764 17.8758 6.95659 17.8583C6.85202 17.8335 6.74684 17.8114 6.64116 17.7919C6.52046 17.7685 6.4007 17.7405 6.28216 17.7078C5.73166 17.5501 5.69221 17.5372 5.27717 17.3674C4.89534 17.2118 4.19183 16.8481 3.95117 16.6827C3.8853 16.637 3.82367 16.6002 3.81424 16.6002C3.80495 16.6002 3.65088 16.4918 3.47185 16.3594C2.33365 15.517 1.47913 14.4943 0.861687 13.2347C0.755437 13.0184 0.668711 12.8264 0.668711 12.8084C0.668711 12.7906 0.649586 12.7413 0.626211 12.6999C0.578 12.6137 0.509336 12.428 0.453953 12.2361C0.430141 12.1545 0.40244 12.0742 0.370945 11.9953C0.345047 11.9342 0.324195 11.8598 0.324195 11.8298C0.324195 11.7997 0.298297 11.7017 0.266687 11.6113C0.235078 11.5217 0.209578 11.4158 0.209578 11.3763C0.209578 11.3369 0.184742 11.2009 0.154062 11.074C0.0794219 10.7605 0 9.94866 0 9.49364C0 9.03916 0.0794219 8.22728 0.154062 7.91397C0.184609 7.78687 0.209578 7.64835 0.209578 7.60585C0.209578 7.56321 0.228836 7.47968 0.252078 7.41991C0.275984 7.36041 0.306531 7.2535 0.320609 7.18244C0.335219 7.11139 0.368422 6.98893 0.395383 6.90951L0.473742 6.68028C0.53125 6.50855 0.584641 6.36325 0.610141 6.30668C0.62475 6.27507 0.681727 6.14597 0.737242 6.0198C0.827023 5.81593 1.01947 5.43144 1.13196 5.23023C1.173 5.15652 1.18854 5.13208 1.4106 4.78504C1.76242 4.23414 2.36366 3.54869 2.92334 3.06007C3.12056 2.88782 3.77945 2.38764 3.80906 2.38764C3.8173 2.38764 3.87945 2.35032 3.94759 2.30464C4.12648 2.18484 4.30193 2.08311 4.53063 1.96849C4.61273 1.92789 4.69403 1.88569 4.77448 1.84192C4.81233 1.82014 4.88338 1.78746 5.24822 1.62411C5.32857 1.58825 5.41516 1.55557 5.66472 1.46832C5.7197 1.44919 5.8302 1.40868 5.90909 1.37907C5.98852 1.34958 6.08188 1.32514 6.11668 1.32514C6.15095 1.32514 6.24112 1.30124 6.31696 1.27175C6.39266 1.24214 6.53013 1.2084 6.62296 1.19698C6.7154 1.18609 6.83825 1.16019 6.89589 1.13987C6.953 1.12021 7.10972 1.09471 7.24399 1.08343C7.41899 1.06761 7.59353 1.04702 7.76741 1.02167C8.12441 0.96934 8.90056 0.96934 9.25384 1.02167C9.42071 1.04561 9.58815 1.06532 9.75601 1.08077C9.88258 1.09126 10.0439 1.11769 10.115 1.13947C10.1861 1.16072 10.309 1.18729 10.3879 1.19698C10.4668 1.20747 10.5996 1.24014 10.683 1.27016C10.7667 1.30071 10.8615 1.32514 10.8942 1.32514C10.9269 1.32514 10.9944 1.34334 11.0436 1.36618C11.0934 1.3885 11.1987 1.42582 11.2782 1.44919C11.3571 1.4731 11.4924 1.52025 11.5797 1.55504C11.6663 1.58971 11.7825 1.63539 11.838 1.65611C11.9402 1.69463 12.6959 2.07275 12.7987 2.13716C13.6329 2.65739 14.0621 2.99725 14.639 3.59332C15.3347 4.31236 15.7965 4.99714 16.2665 6.00519C16.2997 6.07638 16.3504 6.1817 16.3795 6.23868C16.4081 6.29632 16.432 6.36379 16.432 6.38875C16.432 6.41399 16.4559 6.48969 16.4854 6.55729C16.5653 6.74097 16.6337 6.95002 16.666 7.10979C16.6819 7.18815 16.7115 7.28511 16.7317 7.32508C16.752 7.36493 16.7758 7.46626 16.7852 7.54927C16.7945 7.63214 16.822 7.76814 16.8454 7.85062C16.9809 8.31958 17.0482 9.70123 16.9663 10.3123C16.942 10.4939 16.9145 10.7134 16.9052 10.8C16.8895 10.9483 16.8111 11.3318 16.7442 11.5896L16.6751 11.8625C16.545 12.388 16.2233 13.1367 15.8306 13.8293C15.6749 14.1042 15.1531 14.8477 15.0546 14.9348C15.0457 14.9425 15.0016 14.9946 14.9569 15.0495C14.9123 15.105 14.7691 15.2601 14.6395 15.394C14.0683 15.9838 13.6076 16.3485 12.7987 16.8508C12.7029 16.9104 11.8894 17.3078 11.7373 17.3696C11.6584 17.4012 11.5267 17.4546 11.4447 17.4878C11.3633 17.5206 11.2725 17.5481 11.2439 17.5486C11.2154 17.549 11.1402 17.5745 11.0768 17.605C11.0136 17.6356 10.9331 17.6611 10.8974 17.6616C10.8621 17.6621 10.7589 17.6871 10.668 17.7171C10.5773 17.7477 10.4511 17.7805 10.3878 17.7902C10.3246 17.8001 10.1892 17.8271 10.0864 17.8499C9.98378 17.8728 9.6734 17.9174 9.39755 17.949C8.78219 18.0208 8.1605 18.0194 7.54548 17.9449V17.9449ZM8.17009 16.2847C8.20994 16.2537 8.25098 16.1918 8.26187 16.1483C8.28577 16.0523 12.1445 8.31639 12.2172 8.21944C12.2784 8.1375 12.2841 8.00628 12.228 7.96006C12.1986 7.93522 11.8291 7.92739 10.8428 7.92898C10.103 7.93057 9.48109 7.93111 9.46077 7.93057C9.43075 7.92951 9.42451 7.43518 9.42756 5.31789C9.42969 3.88125 9.42291 2.69271 9.41255 2.67625C9.4022 2.65951 9.36169 2.6461 9.32224 2.6461C9.26673 2.6461 9.24083 2.67 9.2067 2.75341C9.14228 2.90854 8.96431 3.26075 8.09798 4.94282C7.91802 5.2919 7.7385 5.64119 7.55942 5.99071C7.40589 6.29114 7.16364 6.76275 7.02193 7.03861C6.64049 7.78013 6.25985 8.52207 5.88001 9.26441C5.22484 10.5442 5.14555 10.6968 5.1174 10.7305C5.06295 10.7964 5.03333 10.9483 5.06401 11.0054C5.0919 11.0578 5.14755 11.0599 6.53066 11.0578C7.32129 11.0568 7.9734 11.061 7.98017 11.0671C7.99837 11.0858 7.99159 16.0223 7.97287 16.14C7.96052 16.2173 7.96875 16.2582 8.00408 16.2935C8.06517 16.3547 8.08191 16.3542 8.17009 16.2847V16.2847Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Git(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M16.5671 7.75318L9.24692 0.433348C8.82564 0.0118008 8.14192 0.0118008 7.71998 0.433348L6.2002 1.95352L8.12838 3.88169C8.57662 3.73042 9.09034 3.83189 9.44747 4.18902C9.61767 4.35937 9.73649 4.57418 9.79034 4.80888C9.8442 5.04358 9.83091 5.28871 9.75201 5.51621L11.6103 7.37479C12.0599 7.2198 12.5788 7.31994 12.9376 7.6796C13.4397 8.18123 13.4397 8.99444 12.9376 9.49634C12.8183 9.6157 12.6767 9.71039 12.5208 9.77499C12.3649 9.83959 12.1978 9.87284 12.029 9.87284C11.8603 9.87284 11.6931 9.83959 11.5372 9.77499C11.3813 9.71039 11.2397 9.6157 11.1204 9.49634C10.9411 9.31698 10.8189 9.08861 10.7692 8.83997C10.7195 8.59133 10.7444 8.33353 10.8408 8.09902L9.10787 6.36595L9.1076 10.9269C9.23333 10.9888 9.34813 11.0708 9.44747 11.1696C9.94937 11.6713 9.94937 12.4842 9.44747 12.9869C8.94557 13.4886 8.1321 13.4886 7.63073 12.9869C7.12896 12.4844 7.08779 11.6714 7.58942 11.1696C7.71347 11.0457 7.83579 10.9521 7.9686 10.8894V6.28626C7.83579 6.22357 7.7136 6.13061 7.58929 6.00589C7.20931 5.62605 7.13826 5.06824 7.33323 4.60127L5.44291 2.70032L0.428704 7.71931C0.00702461 8.14125 0.00968086 8.82497 0.431361 9.24665L7.75278 16.5665C8.1742 16.988 8.85845 16.988 9.28052 16.5665L16.5666 9.28065C16.9883 8.85884 16.9887 8.17472 16.5671 7.75318V7.75318Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Numpy(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M7.21414 3.60773L4.42296 2.19926L1.35791 3.72819L4.22586 5.16788L7.21414 3.60773ZM8.49459 4.25413L11.4216 5.7322L8.38515 7.25649L5.51308 5.81481L8.49459 4.25413ZM12.4042 2.21997L15.4117 3.72806L12.7217 5.0785L9.78898 3.59883L12.4042 2.21997ZM11.1098 1.57039L8.40215 0.212646L5.72412 1.54954L8.51425 2.95602L11.1098 1.57039ZM8.99317 13.2288V16.9231L12.273 15.2863L12.2699 11.5904L8.99317 13.2288ZM12.2683 10.3003L12.2647 6.64329L8.99317 8.26972V11.9283L12.2683 10.3003ZM16.2056 9.61537V13.3243L13.4077 14.7199L13.4056 11.0281L16.2056 9.61537ZM16.2056 8.31846V4.68378L13.4025 6.07725L13.4047 9.74155L16.2056 8.31846Z" />
      <path fill="black" d="M7.8356 8.2697L5.62706 7.15845V11.9583C5.62706 11.9583 2.92459 6.20977 2.67504 5.693C2.64289 5.62606 2.51008 5.55341 2.47635 5.53522C1.98919 5.28102 0.569824 4.5625 0.569824 4.5625V13.0454L2.53346 14.098V9.6621C2.53346 9.6621 5.20684 14.7988 5.23433 14.8553C5.26222 14.9114 5.52904 15.4519 5.81645 15.6424C6.19762 15.8955 7.83453 16.8797 7.83453 16.8797L7.8356 8.2697Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Postgres(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" fillRule="evenodd" clipRule="evenodd" d="M10.7188 1.95539C11.5493 1.77517 12.44 1.79843 13.2403 2.10267C13.7979 2.31977 14.2871 2.68248 14.6569 3.15299C14.8328 3.37662 14.8553 3.67621 14.8669 3.95139C14.8747 4.60523 14.7445 5.25209 14.5778 5.8815C14.26 7.04655 13.7771 8.16276 13.1701 9.20223C13.1106 9.30465 13.0447 9.40328 12.9729 9.49756L12.9504 9.38206C13.026 9.18169 13.1364 8.99294 13.1791 8.78055C13.331 8.18097 13.2023 7.56357 13.1477 6.96012C13.0903 6.39039 13.2825 5.83616 13.2779 5.26798C13.3 4.9897 13.1911 4.72654 13.0849 4.47655C12.7023 3.61149 12.0931 2.84138 11.3121 2.31273C11.1218 2.18057 10.9087 2.08794 10.7188 1.95539Z" />
      <path fill="black" fillRule="evenodd" clipRule="evenodd" d="M8.41074 2.03446C9.43276 1.90308 10.5063 2.18755 11.3183 2.83364C11.9896 3.36965 12.5198 4.09596 12.8054 4.91258C12.3306 4.89591 11.7919 4.87615 11.4078 5.20985C11.0598 5.50673 11.0148 6.01328 11.0931 6.43923C11.2753 7.45118 11.8652 8.3112 12.3012 9.22122C12.4171 9.43477 12.5729 9.62081 12.7205 9.81227C12.5442 9.90257 12.3477 9.98823 12.2477 10.1719C12.0725 10.4576 12.1338 10.806 12.0907 11.1234C11.99 12.0125 11.8908 12.9028 11.7473 13.7861C11.6795 14.2097 11.502 14.6596 11.1059 14.8705C10.7009 15.079 10.23 15.2096 9.77422 15.1391C9.3413 15.0619 9.06883 14.6546 8.94636 14.257C8.85644 13.9236 8.84714 13.576 8.82156 13.2334C8.78148 12.4055 8.77372 11.5764 8.79831 10.7479C8.81652 10.4242 8.65219 10.0874 8.36694 9.93009C8.22858 9.8518 8.06696 9.84095 7.91232 9.82855C8.03363 9.22006 8.40027 8.69412 8.52584 8.08641C8.68901 7.33452 8.5991 6.55162 8.43205 5.80865C8.35066 5.43813 8.07161 5.11024 7.70032 5.02032C7.12903 4.8746 6.55271 5.10094 6.0415 5.34201C6.10584 4.50253 6.32831 3.64328 6.8368 2.96154C7.0242 2.71007 7.25991 2.49855 7.53011 2.33936C7.80031 2.18016 8.09996 2.07651 8.41074 2.03446Z" />
      <path fill="black" fillRule="evenodd" clipRule="evenodd" d="M4.05481 2.10422C4.96483 1.9271 5.89811 2.11468 6.7717 2.38405C6.38267 2.81179 6.08934 3.31758 5.91129 3.86768C5.67293 4.60484 5.56402 5.38929 5.62061 6.16366C5.6559 6.70923 5.63708 7.25696 5.56441 7.79882C5.47023 8.50537 5.75044 9.23246 6.26979 9.70956C5.91632 10.1274 5.54154 10.5262 5.19893 10.9537C5.04777 11.1339 4.84352 11.3482 4.58579 11.2947C4.28426 11.2064 4.09241 10.9281 3.92459 10.6785C3.47113 9.94443 3.19711 9.1158 2.94674 8.29298C2.66614 7.3194 2.42933 6.32992 2.29329 5.32417C2.22547 4.55911 2.26771 3.73823 2.65529 3.05687C2.94519 2.54063 3.48663 2.21196 4.05481 2.10422ZM11.8256 5.63423C11.714 5.72725 11.8346 5.86522 11.9303 5.90902C12.1628 6.047 12.4806 5.85399 12.4884 5.58579C12.2791 5.48734 12.0156 5.49703 11.8256 5.63423ZM11.702 5.50788C12.0369 5.26759 12.4748 5.32107 12.862 5.3451C12.8453 5.88615 12.6802 6.41635 12.7341 6.96128C12.7826 7.63488 12.976 8.35887 12.6616 8.99797C12.2403 8.15035 11.6954 7.3411 11.5055 6.39736C11.4516 6.09661 11.4381 5.7164 11.702 5.50788Z" />
      <path fill="black" fillRule="evenodd" clipRule="evenodd" d="M7.20614 5.64974C7.1418 5.673 7.07437 5.71718 7.08754 5.79625C7.13366 6.06561 7.49062 6.22955 7.71541 6.06173C7.81463 6.00554 7.91889 5.84973 7.80455 5.75594C7.64177 5.62223 7.40419 5.59587 7.20614 5.64974ZM6.02637 5.85632C6.44611 5.58192 6.93716 5.3672 7.44527 5.39666C7.70882 5.40829 7.95183 5.59626 8.015 5.85826C8.246 6.78843 8.31731 7.82248 7.87509 8.70304C7.72282 9.0434 7.59334 9.3935 7.48752 9.75104C6.75191 9.75879 6.12598 9.13015 5.99575 8.42244C5.90661 8.02208 6.02288 7.61939 6.03645 7.21825C6.06745 6.76479 6.03528 6.31017 6.02637 5.85632ZM12.657 10.3239C12.7659 10.2429 12.9205 10.1681 13.0469 10.2568C13.5825 10.5417 14.2049 10.4025 14.7747 10.3332C14.4266 10.675 13.9445 10.8355 13.4705 10.8874C13.1565 10.925 12.8306 10.9362 12.5275 10.8312C12.5291 10.658 12.5198 10.4525 12.657 10.3239ZM7.2635 10.9874C7.57123 10.8204 7.69293 10.4518 7.98051 10.2626C8.29328 10.2177 8.52234 10.6878 8.28553 10.9103C7.82354 11.5428 6.8988 11.6637 6.23101 11.3195C6.56044 11.1649 6.94569 11.1769 7.2635 10.9874Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function PyTorch(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M13.2944 5.08672L12.0726 6.30859C14.078 8.31406 14.078 11.5414 12.0726 13.5203C10.0671 15.5258 6.83975 15.5258 4.86084 13.5203C2.85537 11.5148 2.85537 8.2875 4.86084 6.30859L8.04834 3.12109L8.4999 2.66953V0.265625L3.69209 5.07344C1.02256 7.74297 1.02256 12.0594 3.69209 14.7422C6.36162 17.425 10.678 17.4117 13.3077 14.7422C15.9772 12.0594 15.9772 7.76953 13.2944 5.08672V5.08672Z" />
      <path fill="black" d="M11.7895 3.91721C11.7986 3.42587 11.4076 3.02017 10.9163 3.01107C10.4249 3.00197 10.0192 3.39291 10.0101 3.88426C10.001 4.37561 10.392 4.7813 10.8833 4.7904C11.3747 4.7995 11.7804 4.40856 11.7895 3.91721Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Python(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M9.91379 1.52746C9.33273 1.43182 8.48223 1.38775 7.90492 1.39056C7.3638 1.39118 6.82369 1.43698 6.29019 1.52746C4.8605 1.77752 4.60013 2.29951 4.60013 3.26347V4.39121H8.1009V4.89132H3.46301C2.16398 4.89132 1.10968 6.44385 1.09937 8.36458C1.09937 8.37364 1.09937 8.38271 1.09937 8.39208C1.09892 8.7279 1.13169 9.06294 1.1972 9.3923C1.48758 10.8389 2.39215 11.8928 3.46301 11.8928H4.10002V10.205C4.10002 9.22664 4.75142 8.33113 5.81915 8.1389L6.12765 8.10046H9.91379C10.0728 8.10108 10.2312 8.08005 10.3845 8.03794C10.7351 7.94433 11.0448 7.7371 11.265 7.44871C11.4852 7.16031 11.6036 6.80703 11.6017 6.44416V3.26347C11.6017 2.35952 10.8302 1.67781 9.91379 1.52746ZM6.19204 3.68793C6.06593 3.68837 5.94253 3.65134 5.83749 3.58154C5.73245 3.51175 5.6505 3.41233 5.60204 3.2959C5.55358 3.17947 5.54079 3.05127 5.56529 2.92756C5.58978 2.80385 5.65047 2.6902 5.73964 2.60102C5.82882 2.51185 5.94247 2.45116 6.06618 2.42666C6.18989 2.40217 6.31809 2.41496 6.43452 2.46342C6.55095 2.51188 6.65037 2.59383 6.72017 2.69887C6.78996 2.80391 6.82699 2.92731 6.82656 3.05342C6.8266 3.13676 6.81021 3.21929 6.77834 3.29629C6.74647 3.37329 6.69973 3.44325 6.6408 3.50218C6.58188 3.56111 6.51191 3.60785 6.43491 3.63972C6.35791 3.67159 6.27538 3.68798 6.19204 3.68793Z" />
      <path fill="black" d="M14.9547 7.17262C14.6203 5.84077 13.7542 4.89087 12.7386 4.89087H12.1851V6.37401C12.1851 7.61084 11.3724 8.50635 10.3803 8.65982C10.2801 8.67535 10.1788 8.68319 10.0774 8.68326H6.29034C6.12971 8.68311 5.96972 8.70359 5.8143 8.74421C5.11696 8.92738 4.59998 9.5075 4.59998 10.2599V13.4409C4.59998 14.3473 5.5108 14.8787 6.40443 15.1384C7.47373 15.4494 8.63867 15.5057 9.91832 15.1384C10.7682 14.8956 11.6015 14.4045 11.6015 13.4409V12.3925H8.10074V11.8924H12.7386C13.6588 11.8924 14.4562 11.1132 14.8469 9.97604C15.0185 9.46552 15.1048 8.93021 15.1023 8.39164C15.1031 7.98079 15.0536 7.57139 14.9547 7.17262ZM9.99209 13.0176C10.1182 13.0172 10.2416 13.0542 10.3466 13.124C10.4517 13.1938 10.5336 13.2932 10.5821 13.4097C10.6305 13.5261 10.6433 13.6543 10.6188 13.778C10.5943 13.9017 10.5337 14.0154 10.4445 14.1046C10.3553 14.1937 10.2417 14.2544 10.1179 14.2789C9.99424 14.3034 9.86604 14.2906 9.74961 14.2422C9.63318 14.1937 9.53376 14.1117 9.46396 14.0067C9.39417 13.9017 9.35714 13.7783 9.35757 13.6522C9.35753 13.5688 9.37392 13.4863 9.40579 13.4093C9.43766 13.3323 9.4844 13.2623 9.54333 13.2034C9.60225 13.1445 9.67222 13.0977 9.74922 13.0659C9.82622 13.034 9.90875 13.0176 9.99209 13.0176Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Danger(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_430)">
        <path strokeLinecap="round" strokeMiterlimit="10"  d="M14.384 7.96005V11.0545C14.3839 11.4543 14.2641 11.8449 14.04 12.1759C13.8159 12.507 13.4977 12.7633 13.1265 12.9118L12.3863 13.2078C12.2318 13.2697 12.0951 13.3692 11.9887 13.4973C11.8823 13.6254 11.8096 13.778 11.7771 13.9413L11.4646 15.5086C11.4419 15.6221 11.3805 15.7242 11.2909 15.7975C11.2012 15.8708 11.089 15.9108 10.9732 15.9105H5.79209C5.67648 15.9105 5.56444 15.8705 5.47503 15.7972C5.38562 15.7239 5.32436 15.6219 5.30167 15.5086L4.98817 13.9413C4.95557 13.7782 4.88279 13.6257 4.77642 13.4978C4.67004 13.3699 4.53344 13.2705 4.37897 13.2087L3.63881 12.9127C3.26762 12.7642 2.94943 12.5079 2.7253 12.1769C2.50116 11.8458 2.38136 11.4552 2.38135 11.0554V7.90879C2.38135 4.59807 5.06224 1.91342 8.37171 1.90748C11.6812 1.90154 14.384 4.65339 14.384 7.96005Z" />
        <path strokeLinecap="round" strokeMiterlimit="10"  d="M5.6323 10.9112C6.32331 10.9112 6.88349 10.351 6.88349 9.66001C6.88349 8.96899 6.32331 8.40881 5.6323 8.40881C4.94128 8.40881 4.3811 8.96899 4.3811 9.66001C4.3811 10.351 4.94128 10.9112 5.6323 10.9112Z" />
        <path strokeLinecap="round" strokeMiterlimit="10"  d="M11.1335 10.9112C11.8245 10.9112 12.3847 10.351 12.3847 9.66001C12.3847 8.96899 11.8245 8.40881 11.1335 8.40881C10.4425 8.40881 9.88232 8.96899 9.88232 9.66001C9.88232 10.351 10.4425 10.9112 11.1335 10.9112Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.38484 11.4097L7.88232 12.9172H8.88736L8.38484 11.4097Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.38257 14.9097V15.9189" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M6.88135 14.9097V15.9189" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.88232 14.9097V15.9189" />
      </g>
      <defs>
        <clipPath id="clip0_5_430">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.380615 0.907349)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Doc(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinejoin="round" d="M13.1623 7.19584V13.2831C13.1623 13.681 13.0043 14.0626 12.7229 14.344C12.4415 14.6254 12.0599 14.7834 11.662 14.7834H4.66048C4.26257 14.7834 3.88096 14.6254 3.59959 14.344C3.31823 14.0626 3.16016 13.681 3.16016 13.2831V3.28092C3.16016 2.88301 3.31823 2.5014 3.59959 2.22003C3.88096 1.93866 4.26257 1.78059 4.66048 1.78059H7.74709C8.01227 1.78063 8.26659 1.88598 8.45412 2.07347L12.8695 6.48881C13.0569 6.67634 13.1623 6.93065 13.1623 7.19584Z" />
      <path strokeLinejoin="round" strokeLinecap="round" d="M8.16138 2.03046V5.78182C8.16138 6.04713 8.26677 6.30158 8.45438 6.48918C8.64198 6.67678 8.89643 6.78218 9.16174 6.78218H12.9131" />
      <path strokeLinejoin="round" strokeLinecap="round" d="M5.66089 9.28239H10.6627" />
      <path strokeLinejoin="round" strokeLinecap="round" d="M5.66089 11.7828H10.6627" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function FigmaArrowLeft(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.82862 13.2888L3.32764 8.78784L7.82862 4.28687" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.95361 8.78821H13.0806" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function FigmaArrowRight(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.54395 4.30414L13.0449 8.80512L8.54395 13.3061" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.4202 8.80524H3.29321" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function TreLines(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.30664 8.97961H13.3088" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.30664 6.47888H13.3088" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.30664 11.4795H13.3088" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function FourLines(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.25854 10.479H13.2607"  strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.25854 7.47876H13.2607" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.25854 4.47766H13.2607" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.25854 13.4801H13.2607" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Grid(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.55352 2.36716H2.30198C1.95668 2.36716 1.67676 2.64708 1.67676 2.99238V7.24391C1.67676 7.58922 1.95668 7.86914 2.30198 7.86914H6.55352C6.89882 7.86914 7.17874 7.58922 7.17874 7.24391V2.99238C7.17874 2.64708 6.89882 2.36716 6.55352 2.36716Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.0552 2.36694H9.80369C9.45839 2.36694 9.17847 2.64687 9.17847 2.99217V7.2437C9.17847 7.589 9.45839 7.86893 9.80369 7.86893H14.0552C14.4005 7.86893 14.6804 7.589 14.6804 7.2437V2.99217C14.6804 2.64687 14.4005 2.36694 14.0552 2.36694Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.55327 9.86865H2.30174C1.95644 9.86865 1.67651 10.1486 1.67651 10.4939V14.7454C1.67651 15.0907 1.95644 15.3706 2.30174 15.3706H6.55327C6.89857 15.3706 7.1785 15.0907 7.1785 14.7454V10.4939C7.1785 10.1486 6.89857 9.86865 6.55327 9.86865Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.0552 9.86865H9.80369C9.45839 9.86865 9.17847 10.1486 9.17847 10.4939V14.7454C9.17847 15.0907 9.45839 15.3706 9.80369 15.3706H14.0552C14.4005 15.3706 14.6804 15.0907 14.6804 14.7454V10.4939C14.6804 10.1486 14.4005 9.86865 14.0552 9.86865Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function DateCalendar(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="0.5" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinejoin="round" d="M13.2047 2.62408H3.20248C2.37387 2.62408 1.70215 3.2958 1.70215 4.12441V13.1264C1.70215 13.955 2.37387 14.6267 3.20248 14.6267H13.2047C14.0333 14.6267 14.705 13.955 14.705 13.1264V4.12441C14.705 3.2958 14.0333 2.62408 13.2047 2.62408Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.20312 1.62396V2.63318" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12.2051 1.62396V2.63318" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.705 5.12451H1.70215" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.70483 8.25036L11.0622 7.25H11.2054V12.5019" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.20033 9.70965C6.48529 9.70965 7.00703 9.57577 7.34892 9.22575C7.4609 9.11404 7.5494 8.98104 7.60919 8.8346C7.66898 8.68816 7.69886 8.53123 7.69707 8.37306C7.69707 7.55604 6.99046 7.125 6.19908 7.125C5.52969 7.125 5.15058 7.48816 5.01514 7.71713" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.86011 11.8206C5.01275 12.0793 5.47663 12.6288 6.23267 12.6288C7.12695 12.6288 7.86297 12.1302 7.86297 11.2582C7.86297 10.8634 7.74848 10.5075 7.50075 10.255C7.11413 9.85965 6.52325 9.70825 6.20107 9.70825" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function VideoCamera(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#1B1B1B" strokeWidth="1.0" {...props}>
      <path d="M14 4.75H6C4.20507 4.75 2.75 6.20507 2.75 8V16C2.75 17.7949 4.20507 19.25 6 19.25H14C15.7949 19.25 17.25 17.7949 17.25 16V8C17.25 6.20507 15.7949 4.75 14 4.75Z" />
      <path d="M14.25 9.5C14.25 8.5335 13.4665 7.75 12.5 7.75C11.5335 7.75 10.75 8.5335 10.75 9.5C10.75 10.4665 11.5335 11.25 12.5 11.25C13.4665 11.25 14.25 10.4665 14.25 9.5Z" />
      <path d="M17.75 10.0413C17.75 9.63343 17.949 9.25119 18.2832 9.01728L19.2832 8.31728C20.1116 7.73735 21.25 8.33004 21.25 9.34132V14.6587C21.25 15.67 20.1116 16.2627 19.2832 15.6827L18.2832 14.9827C17.949 14.7488 17.75 14.3666 17.75 13.9587V10.0413Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function People(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#8B949E" strokeWidth="0.8" {...props}>
      <g clipPath="url(#clip0_5_586)">
        <path d="M12.7432 5.75582C12.6516 7.02721 11.7084 8.00663 10.6799 8.00663C9.65144 8.00663 8.70673 7.02752 8.6167 5.75582C8.52291 4.43315 9.44106 3.505 10.6799 3.505C11.9188 3.505 12.837 4.45722 12.7432 5.75582Z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.6793 10.0067C8.64232 10.0067 6.68345 11.0185 6.19272 12.9889C6.12771 13.2496 6.29118 13.5075 6.55905 13.5075H14.7999C15.0678 13.5075 15.2303 13.2496 15.1662 12.9889C14.6755 10.9869 12.7166 10.0067 10.6793 10.0067Z" strokeMiterlimit="10" />
        <path d="M6.42937 6.31713C6.3562 7.33276 5.59385 8.13264 4.77209 8.13264C3.95033 8.13264 3.18672 7.33308 3.1148 6.31713C3.04007 5.26053 3.7821 4.50537 4.77209 4.50537C5.76208 4.50537 6.50411 5.27992 6.42937 6.31713Z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.61604 10.0688C6.05177 9.81023 5.4303 9.71082 4.77162 9.71082C3.14604 9.71082 1.57985 10.5189 1.18752 12.0929C1.13594 12.3011 1.26661 12.5071 1.48043 12.5071H4.99045" strokeMiterlimit="10" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_5_586">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.176514 0.504028)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function CircleTick(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14.1884 8.17745C14.1884 4.86423 11.5003 2.17615 8.1871 2.17615C4.87388 2.17615 2.18579 4.86423 2.18579 8.17745C2.18579 11.4907 4.87388 14.1788 8.1871 14.1788C11.5003 14.1788 14.1884 11.4907 14.1884 8.17745Z" strokeMiterlimit="10" />
      <path d="M11.1887 5.6767L6.98717 10.6785L5.18652 8.67778" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function CirlceAlert(props) {
  const { stroke, ...subProps } = props;
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...subProps}>
      <path d="M14.2138 8.77084C14.2138 5.45762 11.5257 2.76953 8.21249 2.76953C4.89927 2.76953 2.21118 5.45762 2.21118 8.77084C2.21118 12.0841 4.89927 14.7721 8.21249 14.7721C11.5257 14.7721 14.2138 12.0841 14.2138 8.77084Z" stroke={stroke ?? 'black'} strokeWidth="1.0" strokeMiterlimit="10" />
      <path d="M8.03314 5.95894L8.21258 9.77125L8.39171 5.95894C8.39282 5.93457 8.38894 5.91023 8.38032 5.8874C8.3717 5.86458 8.35852 5.84375 8.34158 5.8262C8.32464 5.80864 8.30429 5.79473 8.28179 5.7853C8.25929 5.77587 8.2351 5.77113 8.21071 5.77137V5.77137C8.1866 5.7716 8.16279 5.77668 8.14069 5.78631C8.11859 5.79595 8.09866 5.80994 8.08209 5.82744C8.06552 5.84495 8.05264 5.86562 8.04423 5.88821C8.03582 5.9108 8.03205 5.93486 8.03314 5.95894V5.95894Z" stroke={stroke ?? 'black'} strokeWidth="1.0" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.21555 12.2749C8.09132 12.2749 7.96987 12.238 7.86657 12.169C7.76327 12.1 7.68276 12.0019 7.63522 11.8871C7.58767 11.7723 7.57523 11.646 7.59947 11.5242C7.62371 11.4023 7.68354 11.2904 7.77138 11.2025C7.85923 11.1147 7.97116 11.0549 8.09301 11.0306C8.21485 11.0064 8.34115 11.0188 8.45593 11.0664C8.57071 11.1139 8.66882 11.1944 8.73784 11.2977C8.80686 11.401 8.8437 11.5225 8.8437 11.6467C8.8437 11.8133 8.77752 11.9731 8.65972 12.0909C8.54192 12.2087 8.38215 12.2749 8.21555 12.2749Z" fill={stroke ?? 'black'} />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Discussion(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeMiterlimit="10" strokeLinecap="round" d="M13.6388 10.1963C13.6075 10.0837 13.6763 9.92746 13.7419 9.81493C13.762 9.78144 13.7839 9.74909 13.8076 9.71804C14.369 8.88374 14.6693 7.90117 14.6702 6.89555C14.6796 4.01367 12.2478 1.67566 9.24093 1.67566C6.61848 1.67566 4.43051 3.46042 3.9179 5.82969C3.84121 6.18085 3.80244 6.53923 3.80225 6.89867C3.80225 9.78367 6.14026 12.1842 9.14716 12.1842C9.62539 12.1842 10.2693 12.0404 10.6225 11.9435C10.9757 11.8466 11.3258 11.7185 11.4164 11.6841C11.5093 11.6491 11.6078 11.6311 11.7071 11.631C11.8154 11.6305 11.9228 11.6518 12.0228 11.6935L13.795 12.3217C13.8339 12.3382 13.875 12.3487 13.9169 12.353C13.9833 12.353 14.0469 12.3266 14.0938 12.2797C14.1407 12.2329 14.167 12.1692 14.167 12.1029C14.1648 12.0743 14.1596 12.046 14.1514 12.0185L13.6388 10.1963Z" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M2.24426 7.42685C1.8343 8.16334 1.63599 8.99884 1.67124 9.841C1.70648 10.6832 1.97392 11.4992 2.44399 12.1988C2.51619 12.3079 2.55682 12.3923 2.54432 12.4489C2.53182 12.5055 2.17143 14.3827 2.17143 14.3827C2.16276 14.4267 2.16605 14.4721 2.18095 14.5143C2.19585 14.5566 2.22181 14.594 2.25613 14.6228C2.30193 14.6593 2.35887 14.6789 2.41742 14.6784C2.44871 14.6785 2.47967 14.6721 2.50838 14.6597L4.26532 13.972C4.38624 13.9244 4.52114 13.9266 4.6404 13.9783C5.23241 14.2089 5.88692 14.3534 6.54175 14.3534C7.42047 14.3543 8.28376 14.1225 9.04386 13.6816" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Gallery(props) {
  const { stroke, ...subProps } = props;
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...subProps}>
      <path d="M13.6636 11.1018C13.4573 10.9112 13.1541 10.8643 12.8947 10.8205C12.5353 10.7612 12.3977 10.6955 12.1883 10.508C11.7413 10.111 11.7413 9.53588 12.1883 9.13892L13.1354 8.29811C14.5857 7.01659 14.5857 4.91613 13.1354 3.6346C12.0664 2.69377 10.6317 2.22804 9.14077 2.22804C7.39976 2.22804 5.58062 2.86256 4.17718 4.10658C1.56724 6.41333 1.56724 10.1923 4.17718 12.499C5.47434 13.6462 7.22472 14.2182 8.95635 14.2307H9.00949C10.7411 14.2307 12.4477 13.6712 13.6605 12.5928C14.1106 12.1958 14.0353 11.4488 13.6636 11.1018Z" stroke={stroke ?? 'black'} strokeWidth="1.0" strokeMiterlimit="10" />
      <path d="M4.72215 7.73093C5.27496 7.73093 5.7231 7.28278 5.7231 6.72997C5.7231 6.17716 5.27496 5.72902 4.72215 5.72902C4.16933 5.72902 3.72119 6.17716 3.72119 6.72997C3.72119 7.28278 4.16933 7.73093 4.72215 7.73093Z" fill={stroke ?? 'black'} />
      <path d="M4.97239 10.9503C5.5252 10.9503 5.97334 10.5022 5.97334 9.94938C5.97334 9.39657 5.5252 8.94843 4.97239 8.94843C4.41958 8.94843 3.97144 9.39657 3.97144 9.94938C3.97144 10.5022 4.41958 10.9503 4.97239 10.9503Z" fill={stroke ?? 'black'} />
      <path d="M7.22239 5.73064C7.7752 5.73064 8.22334 5.28249 8.22334 4.72968C8.22334 4.17687 7.7752 3.72873 7.22239 3.72873C6.66958 3.72873 6.22144 4.17687 6.22144 4.72968C6.22144 5.28249 6.66958 5.73064 7.22239 5.73064Z" fill={stroke ?? 'black'} />
      <path d="M8.22287 13.2015C9.05208 13.2015 9.7243 12.5293 9.7243 11.7001C9.7243 10.8709 9.05208 10.1987 8.22287 10.1987C7.39365 10.1987 6.72144 10.8709 6.72144 11.7001C6.72144 12.5293 7.39365 13.2015 8.22287 13.2015Z" fill={stroke ?? 'black'} />
      <path d="M10.4736 5.73054C11.0264 5.73054 11.4746 5.2824 11.4746 4.72959C11.4746 4.17678 11.0264 3.72864 10.4736 3.72864C9.9208 3.72864 9.47266 4.17678 9.47266 4.72959C9.47266 5.2824 9.9208 5.73054 10.4736 5.73054Z" fill={stroke ?? 'black'} />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Planet(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_556)">
        <path d="M13.1184 9.16266C14.9585 10.6392 15.9818 11.9445 15.6286 12.5556C15.0707 13.5199 11.2908 12.3843 7.18614 10.0191C3.0815 7.65389 0.20587 4.95487 0.763491 3.99091C1.11232 3.38827 2.71954 3.60582 4.87814 4.43131" stroke="#57606A" strokeWidth="1.0" strokeMiterlimit="10" />
        <path d="M8.19591 13.2744C10.9579 13.2744 13.197 11.0353 13.197 8.27331C13.197 5.51128 10.9579 3.27222 8.19591 3.27222C5.43389 3.27222 3.19482 5.51128 3.19482 8.27331C3.19482 11.0353 5.43389 13.2744 8.19591 13.2744Z" stroke="#57606A" strokeWidth="1.0" strokeMiterlimit="10" />
      </g>
      <defs>
        <clipPath id="clip0_5_556">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.194336 0.271973)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Calendar(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="#8B949E" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.1971 2.62415H3.19491C2.3663 2.62415 1.69458 3.29586 1.69458 4.12447V13.1264C1.69458 13.955 2.3663 14.6268 3.19491 14.6268H13.1971C14.0257 14.6268 14.6974 13.955 14.6974 13.1264V4.12447C14.6974 3.29586 14.0257 2.62415 13.1971 2.62415Z" stroke="#8B949E" strokeWidth="1.0" strokeLinejoin="round" />
      <path d="M9.45031 8.13274C9.86661 8.13274 10.2041 7.79526 10.2041 7.37896C10.2041 6.96266 9.86661 6.62518 9.45031 6.62518C9.03401 6.62518 8.69653 6.96266 8.69653 7.37896C8.69653 7.79526 9.03401 8.13274 9.45031 8.13274Z" fill="#8B949E" />
      <path d="M11.9498 8.13274C12.3661 8.13274 12.7036 7.79526 12.7036 7.37896C12.7036 6.96266 12.3661 6.62518 11.9498 6.62518C11.5335 6.62518 11.196 6.96266 11.196 7.37896C11.196 7.79526 11.5335 8.13274 11.9498 8.13274Z" fill="#8B949E" />
      <path d="M9.45031 10.6331C9.86661 10.6331 10.2041 10.2956 10.2041 9.87933C10.2041 9.46303 9.86661 9.12555 9.45031 9.12555C9.03401 9.12555 8.69653 9.46303 8.69653 9.87933C8.69653 10.2956 9.03401 10.6331 9.45031 10.6331Z" fill="#8B949E" />
      <path d="M11.9498 10.6331C12.3661 10.6331 12.7036 10.2956 12.7036 9.87933C12.7036 9.46303 12.3661 9.12555 11.9498 9.12555C11.5335 9.12555 11.196 9.46303 11.196 9.87933C11.196 10.2956 11.5335 10.6331 11.9498 10.6331Z" fill="#8B949E" />
      <path d="M4.44934 10.6331C4.86564 10.6331 5.20311 10.2956 5.20311 9.87933C5.20311 9.46303 4.86564 9.12555 4.44934 9.12555C4.03303 9.12555 3.69556 9.46303 3.69556 9.87933C3.69556 10.2956 4.03303 10.6331 4.44934 10.6331Z" fill="#8B949E" />
      <path d="M6.94909 10.6331C7.36539 10.6331 7.70287 10.2956 7.70287 9.87933C7.70287 9.46303 7.36539 9.12555 6.94909 9.12555C6.53279 9.12555 6.19531 9.46303 6.19531 9.87933C6.19531 10.2956 6.53279 10.6331 6.94909 10.6331Z" fill="#8B949E" />
      <path d="M4.44934 13.1338C4.86564 13.1338 5.20311 12.7964 5.20311 12.3801C5.20311 11.9638 4.86564 11.6263 4.44934 11.6263C4.03303 11.6263 3.69556 11.9638 3.69556 12.3801C3.69556 12.7964 4.03303 13.1338 4.44934 13.1338Z" fill="#8B949E" />
      <path d="M6.94909 13.1338C7.36539 13.1338 7.70287 12.7964 7.70287 12.3801C7.70287 11.9638 7.36539 11.6263 6.94909 11.6263C6.53279 11.6263 6.19531 11.9638 6.19531 12.3801C6.19531 12.7964 6.53279 13.1338 6.94909 13.1338Z" fill="#8B949E" />
      <path d="M9.45031 13.1338C9.86661 13.1338 10.2041 12.7964 10.2041 12.3801C10.2041 11.9638 9.86661 11.6263 9.45031 11.6263C9.03401 11.6263 8.69653 11.9638 8.69653 12.3801C8.69653 12.7964 9.03401 13.1338 9.45031 13.1338Z" fill="#8B949E" />
      <path d="M4.19507 1.62396V2.63318" stroke="#8B949E" strokeWidth="1.0" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.1973 1.62402V2.63324" stroke="#8B949E" strokeWidth="1.0" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.6974 5.12482H1.69458" stroke="#8B949E" strokeWidth="1.0" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function UnLink(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.10947 11.91H5.10875C4.31281 11.91 3.54947 11.5938 2.98666 11.031C2.42385 10.4682 2.10767 9.70485 2.10767 8.90892C2.10767 8.11298 2.42385 7.34965 2.98666 6.78683C3.54947 6.22402 4.31281 5.90784 5.10875 5.90784H7.10947" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.1096 5.90784H12.1103C12.9063 5.90784 13.6696 6.22402 14.2324 6.78683C14.7952 7.34965 15.1114 8.11298 15.1114 8.90892C15.1114 9.70485 14.7952 10.4682 14.2324 11.031C13.6696 11.5938 12.9063 11.91 12.1103 11.91H10.1096" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Link(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.91782 11.6717H4.9171C4.12116 11.6717 3.35782 11.3555 2.79501 10.7927C2.2322 10.2298 1.91602 9.46651 1.91602 8.67058C1.91602 7.87464 2.2322 7.1113 2.79501 6.54849C3.35782 5.98568 4.12116 5.66949 4.9171 5.66949H6.91782" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.91772 5.66949H11.9184C12.7144 5.66949 13.4777 5.98568 14.0405 6.54849C14.6033 7.1113 14.9195 7.87464 14.9195 8.67058C14.9195 9.46651 14.6033 10.2298 14.0405 10.7927C13.4777 11.3555 12.7144 11.6717 11.9184 11.6717H9.91772" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.52075 8.66949H11.3797" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Reload(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path stroke={props.$color ?? 'black'} strokeWidth={props.strokeWidth ?? '1.0'} strokeMiterlimit="10" strokeLinecap="round" d="M12.6623 4.68942L12.0022 3.92144C11.4424 3.33355 10.7689 2.8657 10.0227 2.54635C9.2764 2.227 8.47295 2.06284 7.66122 2.06385C4.348 2.06385 1.65991 4.75193 1.65991 8.06516C1.65991 11.3784 4.348 14.0665 7.66122 14.0665C8.90243 14.0664 10.1131 13.6816 11.1266 12.9651C12.1402 12.2487 12.9068 11.2357 13.3209 10.0656" />
      <path fill={props.$color ?? 'black'} d="M14.663 3.10871V6.56558C14.663 6.69824 14.6103 6.82546 14.5165 6.91926C14.4227 7.01306 14.2955 7.06576 14.1628 7.06576H10.706C10.2602 7.06576 10.037 6.52713 10.3521 6.21201L13.8093 2.75483C14.1244 2.43909 14.663 2.66292 14.663 3.10871Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Info(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeMiterlimit="10" d="M7.91214 2.40112C4.73614 2.40112 2.16089 4.97637 2.16089 8.15237C2.16089 11.3284 4.73614 13.9036 7.91214 13.9036C11.0881 13.9036 13.6634 11.3284 13.6634 8.15237C13.6634 4.97637 11.0881 2.40112 7.91214 2.40112Z" />
      <path d="M7.03638 7.27771H8.037V10.905" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.66064 11.0282H9.41327" strokeMiterlimit="10" strokeLinecap="round" />
      <path id="dot" fill={props.stroke ?? 'black'} strokeWidth="0" d="M7.91461 4.46442C7.75342 4.46442 7.59585 4.51222 7.46182 4.60177C7.3278 4.69132 7.22333 4.81861 7.16165 4.96753C7.09996 5.11645 7.08382 5.28032 7.11527 5.43842C7.14672 5.59652 7.22434 5.74174 7.33832 5.85572C7.4523 5.9697 7.59752 6.04732 7.75561 6.07876C7.91371 6.11021 8.07758 6.09407 8.2265 6.03239C8.37542 5.9707 8.50271 5.86624 8.59227 5.73221C8.68182 5.59819 8.72962 5.44061 8.72962 5.27942C8.72962 5.06327 8.64375 4.85597 8.49091 4.70313C8.33807 4.55028 8.13077 4.46442 7.91461 4.46442Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Terminal(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_387)">
        <path strokeLinejoin="round" d="M13.656 2.16333H2.65365C1.82504 2.16333 1.15332 2.83505 1.15332 3.66366V13.6658C1.15332 14.4944 1.82504 15.1662 2.65365 15.1662H13.656C14.4846 15.1662 15.1564 14.4944 15.1564 13.6658V3.66366C15.1564 2.83505 14.4846 2.16333 13.656 2.16333Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.1543 4.16528L5.6552 6.166L3.1543 8.16672" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M6.15503 8.16504H8.15694" />
      </g>
      <defs>
        <clipPath id="clip0_5_387">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.15332 0.66333)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function NoteOpts(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8B949E" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M17 2.75H7C4.65279 2.75 2.75 4.65279 2.75 7V17C2.75 19.3472 4.65279 21.25 7 21.25H17C19.3472 21.25 21.25 19.3472 21.25 17V7C21.25 4.65279 19.3472 2.75 17 2.75Z" />
      <path d="M7 15.8L8.125 17L10 15" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 7.8L8.125 9L10 7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 8H17" strokeLinecap="round" />
      <path d="M13 16H17" strokeLinecap="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Code(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_748)">
        <path strokeWidth="1.5" d="M8.18927 9.04656C8.63939 9.04656 9.00428 8.68167 9.00428 8.23155C9.00428 7.78144 8.63939 7.41655 8.18927 7.41655C7.73916 7.41655 7.37427 7.78144 7.37427 8.23155C7.37427 8.68167 7.73916 9.04656 8.18927 9.04656Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M5.18666 11.7308L1.18579 8.23004L5.18666 4.72928" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.1877 11.7306L15.1886 8.22987L11.1877 4.72911" />
      </g>
      <defs>
        <clipPath id="clip0_5_748">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.18457 0.227905)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Profile(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.3721 4.81724C11.2496 6.47002 9.99663 7.81832 8.62114 7.81832C7.24564 7.81832 5.9905 6.47034 5.87015 4.81724C5.7451 3.09787 6.96429 1.81616 8.62114 1.81616C10.278 1.81616 11.4972 3.12913 11.3721 4.81724Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.62028 9.81848C5.90094 9.81848 3.14096 11.3188 2.63022 14.1507C2.56865 14.492 2.76182 14.8196 3.11908 14.8196H14.1215C14.4791 14.8196 14.6722 14.492 14.6106 14.1507C14.0996 11.3188 11.3396 9.81848 8.62028 9.81848Z" strokeMiterlimit="10" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Game(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_831)">
        <path d="M14.924 8.38767C14.3489 5.78773 13.4959 4.12925 12.1287 3.7251C11.8639 3.64786 11.5893 3.60932 11.3135 3.6107C10.473 3.6107 9.80975 4.11081 8.31286 4.11081C6.81597 4.11081 6.15145 3.6107 5.31221 3.6107C5.02488 3.60921 4.73874 3.64771 4.46202 3.7251C3.09297 4.12925 2.24716 5.7893 1.66548 8.38767C1.0716 11.0417 1.17912 13.1387 2.34 13.5413C3.15267 13.8226 3.8794 13.2409 4.56767 12.3848C5.34909 11.4096 6.31149 11.1095 8.31286 11.1095C10.3142 11.1095 11.2391 11.4096 12.0218 12.3848C12.7094 13.2415 13.463 13.816 14.2542 13.5463C15.5363 13.1084 15.5182 11.0729 14.924 8.38767Z" stroke="black" strokeWidth="1.00189" strokeMiterlimit="10" />
        <path d="M9.44065 8.24269C9.78757 8.24269 10.0688 7.96146 10.0688 7.61454C10.0688 7.26762 9.78757 6.98639 9.44065 6.98639C9.09373 6.98639 8.8125 7.26762 8.8125 7.61454C8.8125 7.96146 9.09373 8.24269 9.44065 8.24269Z" fill="black" />
        <path d="M10.8161 9.61799C10.6918 9.61799 10.5703 9.58111 10.467 9.51202C10.3637 9.44293 10.2831 9.34473 10.2357 9.22986C10.1882 9.11499 10.1758 8.98861 10.2002 8.86672C10.2245 8.74483 10.2845 8.6329 10.3725 8.54512C10.4605 8.45733 10.5726 8.39763 10.6946 8.37357C10.8165 8.34951 10.9429 8.36218 11.0576 8.40996C11.1724 8.45775 11.2704 8.5385 11.3392 8.64201C11.408 8.74551 11.4446 8.86711 11.4443 8.99141C11.4439 9.15774 11.3775 9.31711 11.2597 9.43457C11.142 9.55203 10.9825 9.61799 10.8161 9.61799Z" fill="black" />
        <path d="M10.8161 6.86763C11.1631 6.86763 11.4443 6.58639 11.4443 6.23948C11.4443 5.89256 11.1631 5.61133 10.8161 5.61133C10.4692 5.61133 10.188 5.89256 10.188 6.23948C10.188 6.58639 10.4692 6.86763 10.8161 6.86763Z" fill="black" />
        <path d="M12.1913 8.24269C12.5382 8.24269 12.8194 7.96146 12.8194 7.61454C12.8194 7.26762 12.5382 6.98639 12.1913 6.98639C11.8443 6.98639 11.5631 7.26762 11.5631 7.61454C11.5631 7.96146 11.8443 8.24269 12.1913 8.24269Z" fill="black" />
        <path d="M5.31189 6.11108V9.11394" stroke="black" strokeWidth="1.00189" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.81463 7.61176H3.81177" stroke="black" strokeWidth="1.00189" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5_831">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.310913 0.610229)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Puzzle(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.181 8.3028H12.3164C12.2998 8.3028 12.2839 8.29622 12.2722 8.28449C12.2605 8.27277 12.2539 8.25687 12.2539 8.24029V5.82601C12.2539 5.50387 12.1259 5.19492 11.8981 4.96713C11.6703 4.73934 11.3614 4.61137 11.0392 4.61137H8.62496C8.60838 4.61137 8.59248 4.60479 8.58076 4.59306C8.56903 4.58134 8.56245 4.56544 8.56245 4.54886V3.6843C8.56245 2.83599 7.89042 2.12583 7.04211 2.11114C6.83658 2.10753 6.63239 2.14489 6.44145 2.22103C6.25051 2.29717 6.07665 2.41058 5.93001 2.55464C5.78337 2.69869 5.66688 2.8705 5.58734 3.06006C5.50781 3.24961 5.46682 3.4531 5.46677 3.65866V4.54886C5.46677 4.56544 5.46019 4.58134 5.44846 4.59306C5.43674 4.60479 5.42084 4.61137 5.40426 4.61137H2.98998C2.66184 4.61236 2.34743 4.74315 2.1154 4.97518C1.88337 5.20721 1.75258 5.52163 1.75159 5.84977V8.04962C1.75159 8.0662 1.75817 8.0821 1.7699 8.09383C1.78162 8.10555 1.79752 8.11214 1.8141 8.11214H2.65522C3.57323 8.11214 4.33309 8.90856 4.3459 9.82657C4.35903 10.7602 3.61105 11.6129 2.68023 11.6129H1.8141C1.79752 11.6129 1.78162 11.6195 1.7699 11.6312C1.75817 11.6429 1.75159 11.6588 1.75159 11.6754V13.8753C1.75258 14.2034 1.88337 14.5178 2.1154 14.7499C2.34743 14.9819 2.66184 15.1127 2.98998 15.1137H5.18984C5.20642 15.1137 5.22232 15.1071 5.23404 15.0954C5.24576 15.0836 5.25235 15.0677 5.25235 15.0511V14.3969C5.25235 13.4505 6.02596 12.6356 6.97147 12.6134C7.9123 12.5915 8.75311 13.2483 8.75311 14.185V15.0511C8.75311 15.0677 8.7597 15.0836 8.77142 15.0954C8.78315 15.1071 8.79905 15.1137 8.81563 15.1137H11.0392C11.3614 15.1137 11.6703 14.9857 11.8981 14.7579C12.1259 14.5301 12.2539 14.2212 12.2539 13.899V11.461C12.2539 11.4444 12.2605 11.4285 12.2722 11.4168C12.2839 11.4051 12.2998 11.3985 12.3164 11.3985H13.2066C14.0702 11.3985 14.7544 10.6899 14.7544 9.82313C14.7544 8.95638 14.0293 8.3028 13.181 8.3028Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Levels(props) {

  const { $fill, $lvl, ...subProps } = props;

  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...subProps}>
      <g clipPath="url(#clip0_5_1187)">
        <path
          fill={($fill && $lvl) >= 4 ? $fill : 'none'}
          strokeLinejoin="round"
          d="M14.9472 3.15906H13.4468C13.3087 3.15906 13.1968 3.27101 13.1968 3.40911V12.9112C13.1968 13.0493 13.3087 13.1612 13.4468 13.1612H14.9472C15.0853 13.1612 15.1972 13.0493 15.1972 12.9112V3.40911C15.1972 3.27101 15.0853 3.15906 14.9472 3.15906Z"
        />
        <path
          fill={($fill && $lvl >= 3) ? $fill : 'none'}
          strokeLinejoin="round"
          d="M10.9467 5.65982H9.44634C9.30824 5.65982 9.19629 5.77177 9.19629 5.90988V12.9114C9.19629 13.0495 9.30824 13.1615 9.44634 13.1615H10.9467C11.0848 13.1615 11.1967 13.0495 11.1967 12.9114V5.90988C11.1967 5.77177 11.0848 5.65982 10.9467 5.65982Z"
        />
        <path
          fill={($fill && $lvl >= 2) ? $fill : 'none'}
          strokeLinejoin="round"
          d="M6.9457 7.65982H5.44516C5.30704 7.65982 5.19507 7.77179 5.19507 7.90991V12.9117C5.19507 13.0498 5.30704 13.1618 5.44516 13.1618H6.9457C7.08382 13.1618 7.19579 13.0498 7.19579 12.9117V7.90991C7.19579 7.77179 7.08382 7.65982 6.9457 7.65982Z"
        />
        <path
          fill={($fill && $lvl >= 1) ? $fill : 'none'}
          strokeLinejoin="round"
          d="M2.94543 9.66068H1.44449C1.30633 9.66068 1.19434 9.77267 1.19434 9.91083V12.9127C1.19434 13.0509 1.30633 13.1629 1.44449 13.1629H2.94543C3.08359 13.1629 3.19559 13.0509 3.19559 12.9127V9.91083C3.19559 9.77267 3.08359 9.66068 2.94543 9.66068Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_1187">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.194336 0.158356)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Pause(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" stroke="#8B949E" strokeWidth="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 3.75H7C5.75736 3.75 4.75 4.75736 4.75 6V18C4.75 19.2426 5.75736 20.25 7 20.25H8C9.24264 20.25 10.25 19.2426 10.25 18V6C10.25 4.75736 9.24264 3.75 8 3.75Z" />
      <path d="M17 3.75H16C14.7574 3.75 13.75 4.75736 13.75 6V18C13.75 19.2426 14.7574 20.25 16 20.25H17C18.2426 20.25 19.25 19.2426 19.25 18V6C19.25 4.75736 18.2426 3.75 17 3.75Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Fix(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="#8B949E" strokeWidth="1.0" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeMiterlimit="10" strokeLinecap="round" d="M12.4715 6.06211C12.2835 6.24888 12.0293 6.35371 11.7643 6.35371C11.4993 6.35371 11.2451 6.24888 11.0571 6.06211L10.2266 5.23162C10.0397 5.04367 9.93477 4.78936 9.93477 4.52428C9.93477 4.25919 10.0397 4.00488 10.2266 3.81694L12.1064 1.93621C12.1101 1.93264 12.1129 1.92819 12.1145 1.92328C12.1161 1.91837 12.1164 1.91314 12.1155 1.90807C12.1146 1.90299 12.1124 1.89822 12.1092 1.89419C12.106 1.89016 12.1018 1.88698 12.0971 1.88495C10.8837 1.36484 9.31051 1.6299 8.31154 2.62168C7.35571 3.57032 7.30132 4.99719 7.6514 6.24246C7.70113 6.41947 7.70101 6.60677 7.65104 6.78371C7.60107 6.96065 7.50319 7.12035 7.36821 7.24518L2.16082 12.0009C2.00719 12.1371 1.88303 12.3033 1.796 12.4893C1.70897 12.6753 1.66089 12.8771 1.65473 13.0823C1.64857 13.2876 1.68445 13.4919 1.76017 13.6827C1.8359 13.8736 1.94985 14.047 2.09504 14.1921C2.24024 14.3373 2.41359 14.4513 2.60445 14.527C2.7953 14.6027 2.99963 14.6386 3.20487 14.6325C3.41011 14.6263 3.61192 14.5782 3.79789 14.4912C3.98386 14.4042 4.15007 14.28 4.28629 14.1264L9.09546 8.90648C9.21871 8.77377 9.37575 8.6771 9.54974 8.62683C9.72374 8.57655 9.90814 8.57458 10.0832 8.62111C11.3191 8.95212 12.7256 8.88992 13.669 7.95878C14.6845 6.95856 14.9036 5.19067 14.4113 4.17889C14.4091 4.17447 14.4059 4.17064 14.4019 4.16771C14.3979 4.16478 14.3933 4.16284 14.3884 4.16205C14.3835 4.16125 14.3785 4.16163 14.3738 4.16315C14.3691 4.16466 14.3648 4.16727 14.3613 4.17076L12.4715 6.06211Z" />
      <path fill="black" d="M3.16452 13.6353C3.44321 13.6353 3.66913 13.4094 3.66913 13.1307C3.66913 12.852 3.44321 12.6261 3.16452 12.6261C2.88583 12.6261 2.65991 12.852 2.65991 13.1307C2.65991 13.4094 2.88583 13.6353 3.16452 13.6353Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Fly(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" stroke="#8B949E" strokeWidth="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.43704 5.9581L15.5163 2.93168C19.5892 1.57404 21.8095 3.79435 20.4519 7.86729L17.4255 16.9465C15.389 23.0559 12.0585 23.0489 10.0291 16.9465L9.42103 15.1081C9.26546 14.6414 8.74927 14.1252 8.28258 13.9696L6.43703 13.3544C0.334707 11.325 0.334708 7.98749 6.43704 5.9581Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.05322 14.3302L12.8716 10.5118" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Upload(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#57606A" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_1071)">
        <path d="M10.222 11.7065H12.5976C14.3167 11.7065 15.7232 10.7935 15.7232 9.09341C15.7232 7.39335 14.0666 6.54691 12.7226 6.48034C12.4447 3.82163 10.5034 2.20441 8.2216 2.20441C6.06488 2.20441 4.67583 3.63566 4.22073 5.05503C2.34532 5.23319 0.719971 6.42658 0.719971 8.38075C0.719971 10.3349 2.40784 11.7065 4.47079 11.7065H6.22117" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.2229 8.20612L8.22216 6.2054L6.22144 8.20612" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.22241 14.2202V6.70546" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5_1071">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.220459 0.210632)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Lista(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.18652 4.66956H14.1885" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.18628 8.17023H14.1882" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.18628 11.6718H14.1882" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.6904 5.17914C2.96909 5.17914 3.19501 4.95322 3.19501 4.67453C3.19501 4.39584 2.96909 4.16992 2.6904 4.16992C2.41171 4.16992 2.18579 4.39584 2.18579 4.67453C2.18579 4.95322 2.41171 5.17914 2.6904 5.17914Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.6904 8.6795C2.96909 8.6795 3.19501 8.45358 3.19501 8.1749C3.19501 7.89621 2.96909 7.67029 2.6904 7.67029C2.41171 7.67029 2.18579 7.89621 2.18579 8.1749C2.18579 8.45358 2.41171 8.6795 2.6904 8.6795Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.6904 12.1807C2.96909 12.1807 3.19501 11.9547 3.19501 11.6761C3.19501 11.3974 2.96909 11.1714 2.6904 11.1714C2.41171 11.1714 2.18579 11.3974 2.18579 11.6761C2.18579 11.9547 2.41171 12.1807 2.6904 12.1807Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Store(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" style={{transform: 'scale(1.2)'}} {...props}>
      <path strokeMiterlimit="10" strokeLinecap="round" d="M8.23153 7.25634C11.546 7.25634 14.2328 6.13681 14.2328 4.75579C14.2328 3.37478 11.546 2.25525 8.23153 2.25525C4.9171 2.25525 2.23022 3.37478 2.23022 4.75579C2.23022 6.13681 4.9171 7.25634 8.23153 7.25634Z" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M14.2328 7.44458C14.2328 8.82551 11.5448 9.94512 8.23153 9.94512C4.91831 9.94512 2.23022 8.82551 2.23022 7.44458" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M14.2328 10.1323C14.2328 11.5133 11.5448 12.6329 8.23153 12.6329C4.91831 12.6329 2.23022 11.5133 2.23022 10.1323" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M2.23022 4.73279V12.782C2.23022 14.1498 4.91831 15.2588 8.23153 15.2588C11.5448 15.2588 14.2328 14.1498 14.2328 12.782V4.73279" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function SchoolFigma(props) {
  return (
    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" stroke="#8B949E" strokeWidth="0.7" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'scale(1.55)' }} {...props}>
      <g clipPath="url(#clip0_5_461)">
        <path d="M1.53223 6.60671L8.53375 2.60583L15.5353 6.60671L8.53375 10.6076L1.53223 6.60671Z" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.03198 8.10718V12.108L8.53296 14.6086L13.0339 12.108V8.10718" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.5352 12.1089V6.60693" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.53345 10.6082V14.6096" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_5_461">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.532227 0.60437)"/>
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function FloppyDisk(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12.1363 2.39725C12.0434 2.30437 11.9331 2.23071 11.8118 2.18045C11.6904 2.1302 11.5603 2.10435 11.429 2.10437H3.17467C2.98494 2.10433 2.79706 2.14167 2.62176 2.21426C2.44647 2.28684 2.28719 2.39326 2.15303 2.52742C2.01887 2.66158 1.91246 2.82086 1.83987 2.99615C1.76728 3.17145 1.72994 3.35933 1.72998 3.54906V13.6625C1.72994 13.8522 1.76728 14.0401 1.83987 14.2154C1.91246 14.3907 2.01887 14.55 2.15303 14.6842C2.28719 14.8183 2.44647 14.9247 2.62176 14.9973C2.79706 15.0699 2.98494 15.1072 3.17467 15.1072H13.2881C13.6709 15.106 14.0377 14.9535 14.3084 14.6828C14.5791 14.4121 14.7317 14.0453 14.7328 13.6625V5.40821C14.7328 5.27686 14.707 5.14678 14.6567 5.02541C14.6065 4.90405 14.5328 4.79377 14.4399 4.70087L12.1363 2.39725ZM8.2314 13.6069C7.83575 13.6069 7.44898 13.4896 7.12001 13.2697C6.79104 13.0499 6.53464 12.7375 6.38324 12.372C6.23183 12.0064 6.19221 11.6042 6.2694 11.2162C6.34659 10.8281 6.53711 10.4717 6.81688 10.1919C7.09664 9.91215 7.45308 9.72163 7.84113 9.64444C8.22918 9.56725 8.6314 9.60687 8.99693 9.75828C9.36246 9.90969 9.67489 10.1661 9.8947 10.4951C10.1145 10.824 10.2318 11.2108 10.2318 11.6064C10.2322 11.8692 10.1806 12.1295 10.0802 12.3724C9.97981 12.6152 9.83248 12.8359 9.64665 13.0217C9.46083 13.2075 9.24017 13.3549 8.99732 13.4553C8.75447 13.5557 8.49419 13.6072 8.2314 13.6069V13.6069ZM9.73172 6.60535H3.73042C3.59778 6.60535 3.47057 6.55266 3.37679 6.45887C3.283 6.36508 3.23031 6.23788 3.23031 6.10524V4.10481C3.23031 3.97217 3.283 3.84496 3.37679 3.75118C3.47057 3.65739 3.59778 3.6047 3.73042 3.6047H9.73172C9.86436 3.6047 9.99157 3.65739 10.0854 3.75118C10.1791 3.84496 10.2318 3.97217 10.2318 4.10481V6.10524C10.2318 6.23788 10.1791 6.36508 10.0854 6.45887C9.99157 6.55266 9.86436 6.60535 9.73172 6.60535Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Open(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12.1794 7.7382V13.4895C12.1794 13.6536 12.1471 13.8162 12.0843 13.9679C12.0214 14.1196 11.9293 14.2574 11.8132 14.3735C11.6971 14.4896 11.5593 14.5817 11.4076 14.6446C11.2559 14.7074 11.0933 14.7397 10.9292 14.7397H3.42752C3.09593 14.7397 2.77791 14.608 2.54344 14.3735C2.30897 14.1391 2.17725 13.821 2.17725 13.4895V5.98782C2.17725 5.65623 2.30897 5.33822 2.54344 5.10375C2.77791 4.86927 3.09593 4.73755 3.42752 4.73755H8.66241" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.679 2.73743H14.1811V6.23962" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.17773 9.73986L13.9302 2.98743" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Linkedin(props) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#8B949E" d="M13.8808 1.35615H2.19419C1.55561 1.35615 0.997681 1.81563 0.997681 2.4467V14.1593C0.997681 14.7938 1.55561 15.3592 2.19419 15.3592H13.8774C14.5194 15.3592 15.0007 14.79 15.0007 14.1593V2.4467C15.0045 1.81563 14.5194 1.35615 13.8808 1.35615ZM5.33831 13.0284H3.33225V6.79109H5.33831V13.0284ZM4.40467 5.84275H4.39029C3.74828 5.84275 3.33256 5.36484 3.33256 4.76658C3.33256 4.15739 3.75922 3.69072 4.41561 3.69072C5.072 3.69072 5.47365 4.15395 5.48803 4.76658C5.48772 5.36484 5.072 5.84275 4.40467 5.84275ZM12.6699 13.0284H10.6638V9.61795C10.6638 8.8009 10.3719 8.24265 9.64612 8.24265C9.09163 8.24265 8.76343 8.61773 8.61746 8.98313C8.56276 9.1144 8.54807 9.29319 8.54807 9.47573V13.0284H6.54201V6.79109H8.54807V7.65909C8.84001 7.24337 9.29605 6.64512 10.3572 6.64512C11.6741 6.64512 12.6702 7.51312 12.6702 9.38446L12.6699 13.0284Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Library(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'scale(1.25)' }} {...props}>
      <g clipPath="url(#clip0_5_729)">
        <path d="M3.03414 3.14746H2.03392C1.75772 3.14746 1.53381 3.37137 1.53381 3.64757V14.1499C1.53381 14.4261 1.75772 14.65 2.03392 14.65H3.03414C3.31034 14.65 3.53425 14.4261 3.53425 14.1499V3.64757C3.53425 3.37137 3.31034 3.14746 3.03414 3.14746Z" strokeLinejoin="round" />
        <path d="M4.03418 7.14825H8.03562" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.03418 12.6496H8.03562" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.53494 5.1485H4.53429C4.25809 5.1485 4.03418 5.37241 4.03418 5.64861V14.1505C4.03418 14.4267 4.25809 14.6506 4.53429 14.6506H7.53494C7.81114 14.6506 8.03505 14.4267 8.03505 14.1505V5.64861C8.03505 5.37241 7.81114 5.1485 7.53494 5.1485Z" strokeLinejoin="round" />
        <path d="M11.0357 1.64685H9.03527C8.75906 1.64685 8.53516 1.87076 8.53516 2.14696V14.1496C8.53516 14.4258 8.75906 14.6497 9.03527 14.6497H11.0357C11.3119 14.6497 11.5358 14.4258 11.5358 14.1496V2.14696C11.5358 1.87076 11.3119 1.64685 11.0357 1.64685Z" strokeLinejoin="round" />
        <path d="M13.738 3.1512L12.4752 3.28404C12.1276 3.32061 11.8757 3.64568 11.9148 4.00607L13.0062 14.058C13.0456 14.4183 13.3616 14.6831 13.7092 14.6468L14.972 14.514C15.3196 14.4774 15.5715 14.1523 15.5324 13.792L14.4425 3.74164C14.4016 3.37969 14.0855 3.11463 13.738 3.1512Z" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5_729">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.533081 0.146667)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Houses(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'scale(1.1)' }} {...props}>
      <path fill="#D55C50" stroke="#D55C50" strokeWidth="1.5" d="M8 2.75H5C3.75736 2.75 2.75 3.75736 2.75 5V8C2.75 9.24264 3.75736 10.25 5 10.25H8C9.24264 10.25 10.25 9.24264 10.25 8V5C10.25 3.75736 9.24264 2.75 8 2.75Z" />
      <path fill="#4A6ED8" stroke="#4A6ED8" strokeWidth="1.5" d="M19 2.75H16C14.7574 2.75 13.75 3.75736 13.75 5V8C13.75 9.24264 14.7574 10.25 16 10.25H19C20.2426 10.25 21.25 9.24264 21.25 8V5C21.25 3.75736 20.2426 2.75 19 2.75Z" />
      <path fill="#FFB84D" stroke="#FFB84D" strokeWidth="1.5" d="M19 13.75H16C14.7574 13.75 13.75 14.7574 13.75 16V19C13.75 20.2426 14.7574 21.25 16 21.25H19C20.2426 21.25 21.25 20.2426 21.25 19V16C21.25 14.7574 20.2426 13.75 19 13.75Z" />
      <path fill="#5FCB90" stroke="#5FCB90" strokeWidth="1.5" d="M8 13.75H5C3.75736 13.75 2.75 14.7574 2.75 16V19C2.75 20.2426 3.75736 21.25 5 21.25H8C9.24264 21.25 10.25 20.2426 10.25 19V16C10.25 14.7574 9.24264 13.75 8 13.75Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Briefcase(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_808)">
        <path d="M13.6971 4.1076H2.69466C1.86606 4.1076 1.19434 4.77932 1.19434 5.60793V12.6095C1.19434 13.4381 1.86606 14.1098 2.69466 14.1098H13.6971C14.5257 14.1098 15.1974 13.4381 15.1974 12.6095V5.60793C15.1974 4.77932 14.5257 4.1076 13.6971 4.1076Z"  strokeLinejoin="round" />
        <path d="M4.69556 4.10737V3.10715C4.69556 2.84188 4.80094 2.58747 4.98851 2.39989C5.17609 2.21231 5.4305 2.10693 5.69577 2.10693H10.6969C10.9621 2.10693 11.2165 2.21231 11.4041 2.39989C11.5917 2.58747 11.6971 2.84188 11.6971 3.10715V4.10737" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.1974 7.60797H1.19434" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.1968 7.60797V8.35824C10.1968 8.42457 10.1704 8.48818 10.1235 8.53508C10.0766 8.58198 10.013 8.60833 9.94666 8.60833H6.4454C6.37907 8.60833 6.31546 8.58198 6.26856 8.53508C6.22166 8.48818 6.19531 8.42457 6.19531 8.35824V7.60797" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5_808">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.194336 0.106079)" />
        </clipPath>
      </defs>
    </svg>

  );
}


/**
 *
 *
 *
 */
export function Mail(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.4471 3.93536H2.94485C2.25435 3.93536 1.69458 4.49513 1.69458 5.18564V12.6873C1.69458 13.3778 2.25435 13.9375 2.94485 13.9375H13.4471C14.1376 13.9375 14.6974 13.3778 14.6974 12.6873V5.18564C14.6974 4.49513 14.1376 3.93536 13.4471 3.93536Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.69556 5.93585L8.19654 9.43661L12.6975 5.93585" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Business(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_1618)">
        <path d="M5.75171 13.5964V15.5983" stroke="#8B949E" strokeWidth="1.0" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.7518 1.59375H8.75311C9.01838 1.59375 9.27279 1.69913 9.46037 1.88671C9.64795 2.07428 9.75333 2.32869 9.75333 2.59397V15.4718C9.75333 15.5049 9.74016 15.5367 9.71671 15.5602C9.69326 15.5836 9.66146 15.5968 9.6283 15.5968H1.75159V2.59397C1.75159 2.32869 1.85697 2.07428 2.04454 1.88671C2.23212 1.69913 2.48653 1.59375 2.7518 1.59375V1.59375Z" stroke="#8B949E" strokeWidth="1.0" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.253 6.59454H13.7538C14.0191 6.59454 14.2735 6.69992 14.4611 6.8875C14.6486 7.07508 14.754 7.32949 14.754 7.59476V15.5965H9.75293V7.09465C9.75293 6.96202 9.80562 6.83481 9.89941 6.74102C9.9932 6.64723 10.1204 6.59454 10.253 6.59454Z" stroke="#8B949E" strokeWidth="1.00189" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.32175 11.6006C3.21725 11.6143 3.11108 11.5949 3.01816 11.5451C2.92524 11.4954 2.85023 11.4178 2.80365 11.3232C2.75708 11.2287 2.74128 11.1219 2.75847 11.0179C2.77566 10.914 2.82498 10.818 2.89951 10.7434C2.97403 10.6689 3.07003 10.6196 3.17401 10.6024C3.278 10.5852 3.38476 10.601 3.47931 10.6476C3.57385 10.6942 3.65145 10.7692 3.70119 10.8621C3.75093 10.955 3.77033 11.0612 3.75666 11.1657C3.74224 11.276 3.69178 11.3784 3.61313 11.4571C3.53448 11.5357 3.43204 11.5862 3.32175 11.6006Z" fill="#8B949E" />
        <path d="M3.32175 9.09986C3.21725 9.11353 3.11108 9.09413 3.01816 9.04439C2.92524 8.99465 2.85023 8.91706 2.80365 8.82251C2.75708 8.72796 2.74128 8.6212 2.75847 8.51721C2.77566 8.41323 2.82498 8.31723 2.89951 8.24271C2.97403 8.16818 3.07003 8.11886 3.17401 8.10167C3.278 8.08448 3.38476 8.10028 3.47931 8.14685C3.57385 8.19343 3.65145 8.26844 3.70119 8.36136C3.75093 8.45428 3.77033 8.56045 3.75666 8.66495C3.74224 8.77524 3.69178 8.87768 3.61313 8.95633C3.53448 9.03498 3.43204 9.08544 3.32175 9.09986Z" fill="#8B949E" />
        <path d="M3.32175 6.59956C3.21725 6.61323 3.11108 6.59383 3.01816 6.54408C2.92524 6.49434 2.85023 6.41675 2.80365 6.3222C2.75708 6.22765 2.74128 6.12089 2.75847 6.01691C2.77566 5.91292 2.82498 5.81693 2.89951 5.7424C2.97403 5.66787 3.07003 5.61855 3.17401 5.60136C3.278 5.58417 3.38476 5.59997 3.47931 5.64655C3.57385 5.69312 3.65145 5.76814 3.70119 5.86106C3.75093 5.95398 3.77033 6.06014 3.75666 6.16465C3.74224 6.27494 3.69178 6.37737 3.61313 6.45602C3.53448 6.53467 3.43204 6.58513 3.32175 6.59956Z" fill="#8B949E" />
        <path d="M3.32175 4.09889C3.21725 4.11256 3.11108 4.09316 3.01816 4.04341C2.92524 3.99367 2.85023 3.91608 2.80365 3.82153C2.75708 3.72698 2.74128 3.62022 2.75847 3.51624C2.77566 3.41225 2.82498 3.31626 2.89951 3.24173C2.97403 3.1672 3.07003 3.11788 3.17401 3.10069C3.278 3.0835 3.38476 3.0993 3.47931 3.14588C3.57385 3.19245 3.65145 3.26747 3.70119 3.36039C3.75093 3.45331 3.77033 3.55947 3.75666 3.66398C3.74224 3.77427 3.69178 3.8767 3.61313 3.95535C3.53448 4.034 3.43204 4.08446 3.32175 4.09889Z" fill="#8B949E" />
        <path d="M5.82212 4.09889C5.71761 4.11256 5.61145 4.09316 5.51853 4.04341C5.42561 3.99367 5.3506 3.91608 5.30402 3.82153C5.25744 3.72698 5.24164 3.62022 5.25883 3.51624C5.27602 3.41225 5.32534 3.31626 5.39987 3.24173C5.4744 3.1672 5.57039 3.11788 5.67438 3.10069C5.77836 3.0835 5.88512 3.0993 5.97967 3.14588C6.07422 3.19245 6.15181 3.26747 6.20155 3.36039C6.2513 3.45331 6.2707 3.55947 6.25703 3.66398C6.2426 3.77427 6.19214 3.8767 6.11349 3.95535C6.03484 4.034 5.93241 4.08446 5.82212 4.09889Z" fill="#8B949E" />
        <path d="M8.32273 11.6006C8.21822 11.6143 8.11206 11.5949 8.01914 11.5451C7.92622 11.4954 7.85121 11.4178 7.80463 11.3232C7.75805 11.2287 7.74225 11.1219 7.75944 11.0179C7.77663 10.914 7.82595 10.818 7.90048 10.7434C7.97501 10.6689 8.071 10.6196 8.17499 10.6024C8.27898 10.5852 8.38573 10.601 8.48028 10.6476C8.57483 10.6942 8.65242 10.7692 8.70216 10.8621C8.75191 10.955 8.77131 11.0612 8.75764 11.1657C8.74322 11.276 8.69275 11.3784 8.6141 11.4571C8.53545 11.5357 8.43302 11.5862 8.32273 11.6006Z" fill="#8B949E" />
        <path d="M8.32273 9.09986C8.21822 9.11353 8.11206 9.09413 8.01914 9.04439C7.92622 8.99465 7.85121 8.91706 7.80463 8.82251C7.75805 8.72796 7.74225 8.6212 7.75944 8.51721C7.77663 8.41323 7.82595 8.31723 7.90048 8.24271C7.97501 8.16818 8.071 8.11886 8.17499 8.10167C8.27898 8.08448 8.38573 8.10028 8.48028 8.14685C8.57483 8.19343 8.65242 8.26844 8.70216 8.36136C8.75191 8.45428 8.77131 8.56045 8.75764 8.66495C8.74322 8.77524 8.69275 8.87768 8.6141 8.95633C8.53545 9.03498 8.43302 9.08544 8.32273 9.09986Z" fill="#8B949E" />
        <path d="M8.61668 6.45167C8.81312 6.25523 8.81232 5.93593 8.61489 5.7385C8.41746 5.54106 8.09816 5.54027 7.90172 5.73671C7.70527 5.93316 7.70607 6.25246 7.9035 6.44989C8.10093 6.64732 8.42023 6.64812 8.61668 6.45167Z" fill="#8B949E" />
        <path d="M8.32273 4.09889C8.21822 4.11256 8.11206 4.09316 8.01914 4.04341C7.92622 3.99367 7.85121 3.91608 7.80463 3.82153C7.75805 3.72698 7.74225 3.62022 7.75944 3.51624C7.77663 3.41225 7.82595 3.31626 7.90048 3.24173C7.97501 3.1672 8.071 3.11788 8.17499 3.10069C8.27898 3.0835 8.38573 3.0993 8.48028 3.14588C8.57483 3.19245 8.65242 3.26747 8.70216 3.36039C8.75191 3.45331 8.77131 3.55947 8.75764 3.66398C8.74322 3.77427 8.69275 3.8767 8.6141 3.95535C8.53545 4.034 8.43302 4.08446 8.32273 4.09889Z" fill="#8B949E" />
        <path d="M12.7584 13.0961C12.6586 13.0961 12.561 13.1257 12.478 13.1812C12.3951 13.2366 12.3304 13.3154 12.2922 13.4076C12.254 13.4998 12.244 13.6013 12.2635 13.6992C12.283 13.7971 12.331 13.887 12.4016 13.9576C12.4722 14.0281 12.5621 14.0762 12.6599 14.0957C12.7578 14.1151 12.8593 14.1051 12.9515 14.0669C13.0437 14.0287 13.1225 13.9641 13.178 13.8811C13.2334 13.7981 13.263 13.7005 13.263 13.6007C13.263 13.4669 13.2098 13.3386 13.1152 13.2439C13.0206 13.1493 12.8922 13.0961 12.7584 13.0961Z" fill="#8B949E" />
        <path d="M12.7584 10.5954C12.6586 10.5954 12.561 10.625 12.478 10.6804C12.3951 10.7359 12.3304 10.8147 12.2922 10.9069C12.254 10.9991 12.244 11.1006 12.2635 11.1985C12.283 11.2963 12.331 11.3862 12.4016 11.4568C12.4722 11.5274 12.5621 11.5754 12.6599 11.5949C12.7578 11.6144 12.8593 11.6044 12.9515 11.5662C13.0437 11.528 13.1225 11.4633 13.178 11.3804C13.2334 11.2974 13.263 11.1998 13.263 11.1C13.263 10.9662 13.2098 10.8378 13.1152 10.7432C13.0206 10.6486 12.8922 10.5954 12.7584 10.5954Z" fill="#8B949E" />
        <path d="M12.7584 8.09467C12.6586 8.09467 12.561 8.12426 12.478 8.17971C12.3951 8.23515 12.3304 8.31396 12.2922 8.40617C12.254 8.49837 12.244 8.59983 12.2635 8.69772C12.283 8.7956 12.331 8.88551 12.4016 8.95609C12.4722 9.02666 12.5621 9.07471 12.6599 9.09419C12.7578 9.11366 12.8593 9.10366 12.9515 9.06547C13.0437 9.02728 13.1225 8.9626 13.178 8.87962C13.2334 8.79664 13.263 8.69908 13.263 8.59927C13.263 8.46544 13.2098 8.33709 13.1152 8.24246C13.0206 8.14783 12.8922 8.09467 12.7584 8.09467Z" fill="#8B949E" />
      </g>
      <defs>
        <clipPath id="clip0_5_1618">
          <rect width="16.0" height="16.0" fill="white" transform="translate(0.25061 0.593567)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Location(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.2041 1.91858C5.71919 1.91858 3.70312 3.83743 3.70312 6.20076C3.70312 8.9201 6.70378 13.2295 7.80558 14.7179C7.85132 14.7808 7.91126 14.8319 7.98052 14.8671C8.04978 14.9024 8.12639 14.9208 8.2041 14.9208C8.28182 14.9208 8.35843 14.9024 8.42769 14.8671C8.49695 14.8319 8.55689 14.7808 8.60263 14.7179C9.70443 13.2301 12.7051 8.92229 12.7051 6.20076C12.7051 3.83743 10.689 1.91858 8.2041 1.91858Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.20553 7.92217C9.03475 7.92217 9.70696 7.24996 9.70696 6.42074C9.70696 5.59152 9.03475 4.91931 8.20553 4.91931C7.37631 4.91931 6.7041 5.59152 6.7041 6.42074C6.7041 7.24996 7.37631 7.92217 8.20553 7.92217Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Play(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeMiterlimit="10" d="M3.81128 4.0896V13.1541C3.81128 13.6992 4.34265 14.0455 4.78024 13.7842L12.5288 9.14664C12.9076 8.92003 12.9076 8.32365 12.5288 8.09704L4.78024 3.45947C4.34265 3.19816 3.81128 3.54449 3.81128 4.0896Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function FigmaRefresh(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.2" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.9674 9.43978V8.50833C13.9674 5.42235 11.4593 2.91993 8.36615 2.91993C7.52469 2.91889 6.69383 3.10767 5.93543 3.4722C5.17703 3.83673 4.51063 4.36764 3.98582 5.02538M2.78149 7.58844V8.5199C2.78149 11.6093 5.28829 14.1099 8.38271 14.1099C9.22177 14.1086 10.05 13.9202 10.807 13.5584C11.564 13.1965 12.2308 12.6703 12.7587 12.0182" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M1.38086 8.5162L2.75717 7.13989L4.19604 8.5162" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.3867 8.5144L14.0104 9.89072L12.5715 8.5144" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function FigmaPlus(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="#8B949E" strokeWidth="1.0" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.1792 4.26978V13.2717M12.6802 8.77075H3.67822" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Copy(props) {

  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinejoin="round" d="M12.9238 4.24636H5.98476C5.00079 4.24636 4.20312 5.04403 4.20312 6.028V12.967C4.20312 13.951 5.00079 14.7487 5.98476 14.7487H12.9238C13.9077 14.7487 14.7054 13.951 14.7054 12.967V6.028C14.7054 5.04403 13.9077 4.24636 12.9238 4.24636Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12.1891 4.24647L12.2047 3.49631C12.2034 3.03248 12.0185 2.58803 11.6906 2.26006C11.3626 1.93208 10.9181 1.74725 10.4543 1.74593H3.70283C3.17276 1.74749 2.66485 1.95876 2.29004 2.33357C1.91522 2.70839 1.70396 3.2163 1.70239 3.74636V10.4978C1.70371 10.9617 1.88855 11.4061 2.21653 11.7341C2.5445 12.0621 2.98895 12.2469 3.45277 12.2482H4.20294" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Wand(props) {

  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeMiterlimit="10" d="M7.12465 5.81801C6.7399 5.43326 6.11614 5.43321 5.73145 5.8179C5.34676 6.20259 5.34681 6.82634 5.73156 7.21109L12.6972 14.1767C13.0819 14.5615 13.7057 14.5615 14.0904 14.1768C14.4751 13.7922 14.475 13.1684 14.0903 12.7836L7.12465 5.81801Z" />
      <path d="M5.73589 5.82095C5.644 5.91283 5.57111 6.0219 5.52137 6.14195C5.47164 6.262 5.44604 6.39067 5.44604 6.52061C5.44604 6.65055 5.47164 6.77922 5.52137 6.89927C5.57111 7.01931 5.644 7.12839 5.73589 7.22026L7.13896 8.62333L8.53827 7.22402L7.1352 5.82095C7.04333 5.72906 6.93425 5.65617 6.81421 5.60643C6.69416 5.5567 6.56549 5.53111 6.43555 5.53111C6.30561 5.53111 6.17694 5.5567 6.05689 5.60643C5.93684 5.65617 5.82777 5.72906 5.73589 5.82095Z" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M1.6604 6.24628H3.16796" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M2.97827 3.06372L4.04623 4.13168" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M6.16113 1.74564V3.2532" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M9.35068 3.06371L8.28271 4.13167" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M4.04599 8.36786L2.97803 9.43582" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function FigmaArrow(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="#8B949E" strokeWidth="1.0" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.4109 3.69333L5.90991 8.19431L10.4109 12.6953" />
    </svg>
  );
}

/**
 *
 *
 *
 */
export function Forward(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="#8B949E" strokeWidth="1.0" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinejoin="round" d="M14.1884 8.80516L8.68721 3.55402V6.55467C3.42262 6.55467 2.18579 10.3296 2.18579 14.0563C3.70518 12.1109 5.04891 11.0557 8.68721 11.0557V14.0563L14.1884 8.80516Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Flask(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="#8B949E" strokeWidth="1.0" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient id="rainbow" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%"   style={{ stopColor: 'rgba(255,   0, 0, 1)', stopOpacity: 1}} />
          <stop offset="33%"  style={{ stopColor: 'rgba(255, 165, 0, 1)', stopOpacity: 1}} />
          <stop offset="66%"  style={{ stopColor: 'rgba(255, 255, 0, 1)', stopOpacity: 1}} />
          <stop offset="100%" style={{ stopColor: 'rgba(0,   128, 0, 1)', stopPpacity: 1}} />
        </linearGradient>
      </defs>
      <path strokeMiterlimit="10" strokeLinecap="round" d="M5.72168 1.8331H10.7235" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M3.9082 9.83478H12.5351" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M6.72096 1.8331V4.75499C6.72091 5.13311 6.61385 5.50351 6.41214 5.82334L2.50785 12.0069C1.73237 13.235 2.61475 14.8359 4.06663 14.8359H12.3759C13.8278 14.8359 14.7102 13.235 13.9347 12.0069L10.0301 5.82334C9.82852 5.50347 9.72156 5.13308 9.72161 4.75499V1.8331" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Branch(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.18795 4.60314C6.01717 4.60314 6.68938 3.93093 6.68938 3.10171C6.68938 2.27249 6.01717 1.60028 5.18795 1.60028C4.35874 1.60028 3.68652 2.27249 3.68652 3.10171C3.68652 3.93093 4.35874 4.60314 5.18795 4.60314Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.18795 14.6055C6.01717 14.6055 6.68938 13.9333 6.68938 13.1041C6.68938 12.2749 6.01717 11.6027 5.18795 11.6027C4.35874 11.6027 3.68652 12.2749 3.68652 13.1041C3.68652 13.9333 4.35874 14.6055 5.18795 14.6055Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M5.18652 11.6026V4.6011" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M11.1877 6.60336C12.0169 6.60336 12.6891 5.93114 12.6891 5.10192C12.6891 4.27271 12.0169 3.60049 11.1877 3.60049C10.3585 3.60049 9.68628 4.27271 9.68628 5.10192C9.68628 5.93114 10.3585 6.60336 11.1877 6.60336Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M11.1887 6.6015C11.1887 10.6029 5.18652 8.10204 5.18652 11.6033" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Eye(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#8B949E" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5_1419)">
        <path strokeWidth="1.0" strokeLinecap="round" strokeLinejoin="round" d="M8.1506 3.81589C5.71444 3.81589 3.21546 5.22588 1.24815 8.04587C1.192 8.12725 1.16123 8.22345 1.15973 8.32231C1.15822 8.42117 1.18606 8.51826 1.23972 8.6013C2.75129 10.9674 5.21683 12.8178 8.1506 12.8178C11.0525 12.8178 13.5686 10.9618 15.083 8.59036C15.1354 8.50894 15.1633 8.41416 15.1633 8.31734C15.1633 8.22051 15.1354 8.12573 15.083 8.04431C13.5652 5.70005 11.0306 3.81589 8.1506 3.81589Z" />
        <path strokeWidth="1.0" strokeMiterlimit="10" d="M8.16179 10.8177C9.543 10.8177 10.6627 9.69803 10.6627 8.31682C10.6627 6.93561 9.543 5.81592 8.16179 5.81592C6.78058 5.81592 5.66089 6.93561 5.66089 8.31682C5.66089 9.69803 6.78058 10.8177 8.16179 10.8177Z" />
      </g>
      <defs>
        <clipPath id="clip0_5_1419">
          <rect width="16.0035" height="16.0035" fill="white" transform="translate(0.159668 0.315125)" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Merge(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" stroke="red" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M4.16134 15.3725C4.99056 15.3725 5.66277 14.7003 5.66277 13.8711C5.66277 13.0419 4.99056 12.3697 4.16134 12.3697C3.33213 12.3697 2.65991 13.0419 2.65991 13.8711C2.65991 14.7003 3.33213 15.3725 4.16134 15.3725Z" />
      <path strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M4.16064 5.36801V12.3695" />
      <path strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M9.16307 5.86887L7.16235 3.86815L9.16307 1.86743" />
      <path strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M4.16159 5.36999C4.9908 5.36999 5.66302 4.69777 5.66302 3.86856C5.66302 3.03934 4.9908 2.36713 4.16159 2.36713C3.33237 2.36713 2.66016 3.03934 2.66016 3.86856C2.66016 4.69777 3.33237 5.36999 4.16159 5.36999Z" />
      <path strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M12.1628 15.3725C12.992 15.3725 13.6642 14.7003 13.6642 13.8711C13.6642 13.0419 12.992 12.3697 12.1628 12.3697C11.3336 12.3697 10.6614 13.0419 10.6614 13.8711C10.6614 14.7003 11.3336 15.3725 12.1628 15.3725Z" />
      <path strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M7.66162 3.86758H10.2872C10.7846 3.86758 11.2616 4.06517 11.6133 4.41688C11.965 4.76859 12.1626 5.2456 12.1626 5.74299V12.3694" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function DatabaseTable(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_703_30642)">
        <path stroke="#57606A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M3 5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5Z" />
        <path stroke="#57606A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M3 10H21" />
        <path stroke="#57606A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M10 3V21" />
      </g>
      <defs>
        <clipPath id="clip0_703_30642">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Map(props) {
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path stroke="#57606A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M13.0024 4.83141L9.42228 2.54091C9.27986 2.46977 9.12253 2.43365 8.96335 2.43556C8.80417 2.43746 8.64775 2.47733 8.50708 2.55185L4.97693 4.92049C4.89662 4.96304 4.82942 5.02667 4.78255 5.10454C4.73569 5.18241 4.71093 5.27158 4.71094 5.36246V14.6082C4.71093 14.6945 4.73323 14.7793 4.77566 14.8543C4.8181 14.9294 4.87923 14.9923 4.95313 15.0367C5.02702 15.0812 5.11116 15.1058 5.19737 15.1082C5.28359 15.1106 5.36895 15.0906 5.44516 15.0502L8.5027 13.0563C8.64452 12.9812 8.80234 12.9413 8.96282 12.94C9.12331 12.9387 9.28175 12.976 9.42478 13.0488L12.9212 15.3306C13.0629 15.4028 13.2199 15.4402 13.379 15.4396C13.5381 15.439 13.6948 15.4004 13.8361 15.3271L17.444 12.9535C17.5253 12.9113 17.5935 12.8476 17.641 12.7693C17.6886 12.6911 17.7138 12.6012 17.7138 12.5096V3.26638C17.7138 3.18013 17.6915 3.09535 17.649 3.02027C17.6066 2.94518 17.5455 2.88235 17.4716 2.83787C17.3977 2.79339 17.3136 2.76877 17.2273 2.76642C17.1411 2.76406 17.0558 2.78404 16.9795 2.82441L13.9164 4.82047C13.7759 4.89478 13.6197 4.93454 13.4607 4.93644C13.3018 4.93834 13.1447 4.90234 13.0024 4.83141Z" />
        <path stroke="#57606A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M13.4631 4.93585V15.4381" />
        <path stroke="#57606A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M8.96167 2.43604V12.9383" />
      </g>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Chart(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#57606A" fillRule="evenodd" clipRule="evenodd" d="M9.45332 3.35117C9.89809 3.25639 10.2965 3.61138 10.2965 4.06614C10.2965 4.44372 10.0176 4.75995 9.64952 4.84431C6.12733 5.65159 3.5 8.80499 3.5 12.572C3.5 16.9505 7.04948 20.5 11.428 20.5C15.19 20.5 18.3399 17.8798 19.1524 14.3647C19.2374 13.9973 19.5533 13.7191 19.9304 13.7191C20.3858 13.7191 20.7409 14.1185 20.6452 14.5637C19.7312 18.8141 15.9516 22 11.428 22C6.22105 22 2 17.779 2 12.572C2 8.04238 5.19439 4.25881 9.45332 3.35117Z" />
      <mask id="mask0_2_23" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="12" y="2" width="10" height="10">
        <path fill="white" d="M20.0146 12C21.1192 12 22.0348 11.0958 21.8153 10.0133C21.6879 9.38479 21.5 8.76849 21.2534 8.17317C20.7509 6.95991 20.0143 5.85752 19.0857 4.92893C18.1571 4.00035 17.0547 3.26375 15.8415 2.7612C15.2462 2.51461 14.6299 2.32674 14.0014 2.19934C12.9188 1.97989 12.0146 2.89543 12.0146 4V10C12.0146 11.1046 12.9101 12 14.0146 12H20.0146Z" />
      </mask>
      <g mask="url(#mask0_2_23)">
        <path stroke="#57606A" strokeWidth="3" d="M20.0146 12C21.1192 12 22.0348 11.0958 21.8153 10.0133C21.6879 9.38479 21.5 8.76849 21.2534 8.17317C20.7509 6.95991 20.0143 5.85752 19.0857 4.92893C18.1571 4.00035 17.0547 3.26375 15.8415 2.7612C15.2462 2.51461 14.6299 2.32674 14.0014 2.19934C12.9188 1.97989 12.0146 2.89543 12.0146 4V10C12.0146 11.1046 12.9101 12 14.0146 12H20.0146Z" />
      </g>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Star(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" stroke="#1B1B1B" strokeWidth="1" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.1168 3.66283C11.4928 2.95492 12.5072 2.95492 12.8832 3.66283L14.8392 7.34568C14.9837 7.61783 15.2457 7.80813 15.5492 7.8615L19.6562 8.58374C20.4457 8.72256 20.7591 9.68727 20.202 10.2636L17.3039 13.262C17.0897 13.4835 16.9897 13.7915 17.0327 14.0966L17.615 18.2258C17.7269 19.0195 16.9062 19.6157 16.186 19.264L12.4388 17.4343C12.1619 17.299 11.8381 17.299 11.5612 17.4343L7.81402 19.264C7.09374 19.6157 6.27311 19.0195 6.38503 18.2258L6.96729 14.0966C7.01032 13.7915 6.91027 13.4835 6.69611 13.262L3.79796 10.2636C3.24088 9.68727 3.55434 8.72256 4.34379 8.58374L8.45083 7.8615C8.75432 7.80813 9.01627 7.61782 9.16081 7.34568L11.1168 3.66283Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function SixDots(props) {

  return (
    <svg id="SixDots" width="24" height="24" viewBox="0 0 24 24" stroke="#8B949E" fill="#8B949E" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeWidth="0" d="M14 6C14 6.55228 14.4477 7 15 7C15.5523 7 16 6.55228 16 6C16 5.44772 15.5523 5 15 5C14.4477 5 14 5.44772 14 6Z" />
      <path strokeWidth="0" d="M14 12C14 12.5523 14.4477 13 15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12Z" />
      <path strokeWidth="0" d="M14 18C14 18.5523 14.4477 19 15 19C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17C14.4477 17 14 17.4477 14 18Z" />
      <path strokeWidth="0" d="M8 6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5C8.44772 5 8 5.44772 8 6Z" />
      <path strokeWidth="0" d="M8 12C8 12.5523 8.44772 13 9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12Z" />
      <path strokeWidth="0" d="M8 18C8 18.5523 8.44772 19 9 19C9.55228 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Moon(props) {

  return (
    <svg viewBox="0 0 14 13" width="14" height="13" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.52208 7.71754C7.5782 7.71754 10.0557 5.24006 10.0557 2.18394C10.0557 1.93498 10.0392 1.68986 10.0074 1.44961C9.95801 1.07727 10.3495 0.771159 10.6474 0.99992C12.1153 2.12716 13.0615 3.89999 13.0615 5.89383C13.0615 9.29958 10.3006 12.0605 6.89485 12.0605C3.95334 12.0605 1.49286 10.001 0.876728 7.24527C0.794841 6.87902 1.23668 6.65289 1.55321 6.85451C2.41106 7.40095 3.4296 7.71754 4.52208 7.71754Z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Bell(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" width="20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10.75v5l2 2v1H4v-1l2-2v-5c0-3.08 1.64-5.64 4.5-6.32v-.68c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.68c2.87.68 4.5 3.25 4.5 6.32zm-4 9c0 1.1-.9 2-2 2s-2-.9-2-2h4z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Plus(props) {

  return (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#8B949E" {...props}>
      <path
        d="M12 5v14M5 12h14"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Inbox(props) {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#57606A" d="M16 22.75H8C2.25 22.75 2.25 19.7 2.25 17V16C2.25 13.77 2.25 11.25 7 11.25C8.19 11.25 8.63 11.54 9.25 12C9.28 12.03 9.32 12.05 9.35 12.09L10.37 13.17C11.23 14.08 12.79 14.08 13.65 13.17L14.67 12.09C14.7 12.06 14.73 12.03 14.77 12C15.39 11.53 15.83 11.25 17.02 11.25C21.77 11.25 21.77 13.77 21.77 16V17C21.75 20.82 19.82 22.75 16 22.75ZM7 12.75C3.75 12.75 3.75 13.77 3.75 16V17C3.75 19.74 3.75 21.25 8 21.25H16C18.98 21.25 20.25 19.98 20.25 17V16C20.25 13.77 20.25 12.75 17 12.75C16.28 12.75 16.13 12.84 15.7 13.16L14.73 14.19C14.01 14.95 13.04 15.37 12 15.37C10.96 15.37 9.99 14.95 9.27 14.19L8.3 13.16C7.87 12.84 7.72 12.75 7 12.75Z" />
      <path fill="#57606A" d="M19 12.75C18.59 12.75 18.25 12.41 18.25 12V6C18.25 3.77 18.25 2.75 15 2.75H9C5.75 2.75 5.75 3.77 5.75 6V12C5.75 12.41 5.41 12.75 5 12.75C4.59 12.75 4.25 12.41 4.25 12V6C4.25 3.77 4.25 1.25 9 1.25H15C19.75 1.25 19.75 3.77 19.75 6V12C19.75 12.41 19.41 12.75 19 12.75Z" />
      <path fill="#57606A" d="M13.8798 9.97998H10.5498C10.1398 9.97998 9.7998 9.63998 9.7998 9.22998C9.7998 8.81998 10.1398 8.47998 10.5498 8.47998H13.8798C14.2898 8.47998 14.6298 8.81998 14.6298 9.22998C14.6298 9.63998 14.2998 9.97998 13.8798 9.97998Z" />
      <path fill="#57606A" d="M14.7197 6.97998H9.71973C9.30973 6.97998 8.96973 6.63998 8.96973 6.22998C8.96973 5.81998 9.30973 5.47998 9.71973 5.47998H14.7197C15.1297 5.47998 15.4697 5.81998 15.4697 6.22998C15.4697 6.63998 15.1397 6.97998 14.7197 6.97998Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Message(props) {

  return (
    <svg viewBox="0 0 28 28" height="28" width="28">
      <path d="M14 2.042c6.76 0 12 4.952 12 11.64S20.76 25.322 14 25.322a13.091 13.091 0 0 1-3.474-.461.956 .956 0 0 0-.641.047L7.5 25.959a.961.961 0 0 1-1.348-.849l-.065-2.134a.957.957 0 0 0-.322-.684A11.389 11.389 0 0 1 2 13.682C2 6.994 7.24 2.042 14 2.042ZM6.794 17.086a.57.57 0 0 0 .827.758l3.786-2.874a.722.722 0 0 1 .868 0l2.8 2.1a1.8 1.8 0 0 0 2.6-.481l3.525-5.592a.57.57 0 0 0-.827-.758l-3.786 2.874a.722.722 0 0 1-.868 0l-2.8-2.1a1.8 1.8 0 0 0-2.6.481Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Heart(props) {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#414143"
        d="M10 2.9152C11.09 1.6352 12.76 0.825195 14.5 0.825195C17.58 0.825195 20 3.2452 20 6.3252C20 10.1021 16.6056 13.1801 11.4627 17.8437L11.45 17.8552L10 19.1752L8.55 17.8652L8.51052 17.8293C3.38263 13.1694 0 10.0955 0 6.3252C0 3.2452 2.42 0.825195 5.5 0.825195C7.24 0.825195 8.91 1.6352 10 2.9152ZM10 16.4752L10.1 16.3752C14.86 12.0652 18 9.2152 18 6.3252C18 4.3252 16.5 2.8252 14.5 2.8252C12.96 2.8252 11.46 3.8152 10.94 5.18519H9.07C8.54 3.8152 7.04 2.8252 5.5 2.8252C3.5 2.8252 2 4.3252 2 6.3252C2 9.2152 5.14 12.0652 9.9 16.3752L10 16.4752Z"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function HeartActive(props) {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M14.5 0.825195C12.76 0.825195 11.09 1.6352 10 2.9152C8.91 1.6352 7.24 0.825195 5.5 0.825195C2.42 0.825195 0 3.2452 0 6.3252C0 10.1052 3.4 13.1852 8.55 17.8652L10 19.1752L11.45 17.8552C16.6 13.1852 20 10.1052 20 6.3252C20 3.2452 17.58 0.825195 14.5 0.825195Z"
        fill="#EB5757"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Write(props) {

  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#414143"
        d="M4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2zm2 14h14V4H4v14l2-2z"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Close(props) {
  return (
    <svg width="18" height="18" stroke="#8B949E" viewBox="0 0 18 18" strokeWidth="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" d="M13 5L5 13" />
      <path strokeLinecap="round" d="M13 13L5 5" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Camera(props) {

  return (
    <svg viewBox="0 0 36 32" color="rgba(65, 65, 67, 1)" width="20" height="20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75.25h10.5l3.203 3.5H32a3.51 3.51 0 013.5 3.5v21a3.51 3.51 0 01-3.5 3.5H4a3.51 3.51 0 01-3.5-3.5v-21A3.51 3.51 0 014 3.75h5.547L12.75.25zm12.163 7l-3.203-3.5h-7.42l-3.202 3.5H4v21h28v-21h-7.087zM18 12.5c2.887 0 5.25 2.363 5.25 5.25S20.887 23 18 23s-5.25-2.363-5.25-5.25S15.113 12.5 18 12.5zm-8.75 5.25C9.25 12.92 13.17 9 18 9s8.75 3.92 8.75 8.75S22.83 26.5 18 26.5s-8.75-3.92-8.75-8.75z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function ThreeDots(props) {

  return (
    <svg viewBox="0 0 24 24" color="rgba(65, 65, 67, 1)" width="24" height="24">
      <path
        fill="currentColor"
        d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Dots(props) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" stroke="#8B949E" strokeWidth="1.8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cy="9" r="0.8" cx="3" />
      <circle cy="9" r="0.8" cx="9" />
      <circle cy="9" r="0.8" cx="15" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Expand(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 15.5 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.7148 10.2997V13.8019H10.2126" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.3962 13.482L9.71265 9.79942"  strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.71118 6.30021V2.79802H6.21337" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.03052 3.11763L6.71407 6.80024" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.2126 2.79802H13.7148V6.30021" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.3953 3.11664L9.71265 6.80019" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.21337 13.8019H2.71118V10.2997" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.03149 13.483L6.71411 9.79942"  strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Pane(props) {
  const { $isActive, ...subProps } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#57606A" strokeWidth="1.7" xmlns="http://www.w3.org/2000/svg" {...subProps}>
      <path fill={$isActive ? '#57606A' : 'none'}  d="M8 2.75H5C3.75736 2.75 2.75 3.75736 2.75 5V19C2.75 20.2426 3.75736 21.25 5 21.25H8C9.24264 21.25 10.25 20.2426 10.25 19V5C10.25 3.75736 9.24264 2.75 8 2.75Z" />
      <path d="M19 2.75H16C14.7574 2.75 13.75 3.75736 13.75 5V8C13.75 9.24264 14.7574 10.25 16 10.25H19C20.2426 10.25 21.25 9.24264 21.25 8V5C21.25 3.75736 20.2426 2.75 19 2.75Z" />
      <path d="M19 13.75H16C14.7574 13.75 13.75 14.7574 13.75 16V19C13.75 20.2426 14.7574 21.25 16 21.25H19C20.2426 21.25 21.25 20.2426 21.25 19V16C21.25 14.7574 20.2426 13.75 19 13.75Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Collapse(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 15.5 17" fill="none" stroke="#8B949E" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.68628 13.2499V9.74773H13.1885" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.0061 10.0676L13.6897 13.7502" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.68847 3.24636V6.74855H3.18628" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.36861 6.4288L2.68506 2.74619"  strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.1885 6.74853H9.68628V3.24634" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.0073 6.42976L13.6899 2.74621" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.18604 9.74773H6.68822V13.2499" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.36767 10.0664L2.68506 13.7499" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Bin(props) {

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="#8B949E" strokeWidth="1.15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 4.48499C13.2525 4.23749 10.74 4.10999 8.235 4.10999C6.75 4.10999 5.265 4.18499 3.78 4.33499L2.25 4.48499" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.375 3.7275L6.54 2.745C6.66 2.0325 6.75 1.5 8.0175 1.5H9.9825C11.25 1.5 11.3475 2.0625 11.46 2.7525L11.625 3.7275" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.1374 6.85498L13.6499 14.4075C13.5674 15.585 13.4999 16.5 11.4074 16.5H6.59243C4.49993 16.5 4.43243 15.585 4.34993 14.4075L3.86243 6.85498" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.74719 12.375H10.2447" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.125 9.375H10.875" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Embed(props) {

  return (
    <svg viewBox="0 0 24 24" color="rgb(224, 36, 94)" width="20" height="20">
      <g>
        <path
          d="M23.804 11.5l-6.496-7.25c-.278-.31-.752-.334-1.06-.06-.308.277-.334.752-.058 1.06L22.238 12l-6.047 6.75c-.275.308-.25.782.06 1.06.142.127.32.19.5.19.204 0 .41-.084.558-.25l6.496-7.25c.252-.28.258-.713 0-1zm-23.606 0l6.496-7.25c.278-.31.752-.334 1.06-.06.308.277.334.752.058 1.06L1.764 12l6.047 6.75c.277.308.25.782-.057 1.06-.143.127-.322.19-.5.19-.206 0-.41-.084-.56-.25L.197 12.5c-.252-.28-.257-.713 0-1zm9.872 12c-.045 0-.09-.004-.135-.012-.407-.073-.68-.463-.605-.87l3.863-21.5c.074-.407.466-.674.87-.606.408.073.68.463.606.87l-3.864 21.5c-.065.363-.38.618-.737.618z"
        />
      </g>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Connect(props) {

  return (
    <svg viewBox="0 0 24 24" color="rgba(255, 255, 255, 1)" width="20" height="20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1a1 1 0 001 1h14a1 1 0 001-1v-1c0-2.66-5.33-4-8-4zm-9 0a1 1 0 11-2 0v-2H2a1 1 0 110-2h2V8a1 1 0 012 0v2h2a1 1 0 110 2H6v2z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Triangle(props) {

  return (
    <svg viewBox="7 7 9 10" fill="none" color="rgba(65, 65, 67, 1)" width="11" height="11" {...props}>
      <path d="m 9 17 l 5 -4 l -5 -4 v 8 z" fill="currentColor" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Lock(props) {

  return (
    <svg width="18" height="18" fill="none" color="rgba(255, 255, 255, 1)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4.667h-.667V3.333a3.335 3.335 0 00-6.667 0v1.334H2c-.734 0-1.333.6-1.333 1.333v6.667C.667 13.4 1.267 14 2 14h8c.733 0 1.333-.6 1.333-1.333V6c0-.733-.6-1.333-1.333-1.333zM4 3.333c0-1.106.893-2 2-2 1.106 0 2 .894 2 2v1.334H4V3.333zm3.333 6c0 .734-.6 1.334-1.333 1.334-.734 0-1.333-.6-1.333-1.334C4.667 8.6 5.266 8 6 8s1.333.6 1.333 1.333z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Clock(props) {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#57606A" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5V12L15 15" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Search(props) {

  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="#57606A" strokeWidth="1.20189" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeMiterlimit="10" d="M7.51804 2.60583C6.54691 2.60583 5.59759 2.89381 4.79012 3.43334C3.98265 3.97287 3.35331 4.73973 2.98167 5.63694C2.61004 6.53415 2.5128 7.52141 2.70226 8.47388C2.89172 9.42636 3.35936 10.3013 4.04606 10.988C4.73275 11.6746 5.60765 12.1423 6.56012 12.3317C7.5126 12.5212 8.49986 12.424 9.39707 12.0523C10.2943 11.6807 11.0611 11.0514 11.6007 10.2439C12.1402 9.43642 12.4282 8.4871 12.4282 7.51596C12.4281 6.21374 11.9107 4.96488 10.9899 4.04407C10.0691 3.12326 8.82026 2.60592 7.51804 2.60583V2.60583Z" />
      <path strokeMiterlimit="10" strokeLinecap="round" d="M11.1809 11.1793L14.6115 14.6099" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Event(props) {

  return (
    <svg viewBox="0 0 24 24" color="rgba(6, 189, 182, 1)" width="40" height="40" {...props}>
      <path
        d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Arrow(props) {

  return (
    <svg viewBox="0 0 17 17" color="rgba(65, 65, 67, 1)" width="14.4" height="14.4" {...props}>
      <path
        fill="currentColor"
        d="M8.5.5L7.09 1.91l5.58 5.59H.5v2h12.17l-5.58 5.59L8.5 16.5l8-8-8-8z"
      />
    </svg>
  );
}

/**
 *
 *
 *
 */
export function WhiteArrow(props) {

  return (
    <svg viewBox="0 0 17 17" color="rgba(255, 255, 255, 1)" width="17" height="17">
      <path
        fill="currentColor"
        d="M8.5.5L7.09 1.91l5.58 5.59H.5v2h12.17l-5.58 5.59L8.5 16.5l8-8-8-8z">
      </path>
    </svg>
  );
}

/**
 *
 *
 *
 */
export function ArrowRight(props) {

  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" {...props}>
      <path d="M12.5 4.5L11.09 5.91L16.67 11.5H4.5V13.5H16.67L11.09 19.09L12.5 20.5L20.5 12.5L12.5 4.5Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Dir(props) {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_2_171" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="2" y="3" width="20" height="17">
        <path fill="white" fillRule="evenodd" clipRule="evenodd" d="M13.1 4.5C12.5982 3.57562 11.6307 3 10.5789 3H5C3.34315 3 2 4.34315 2 6V8V14C2 16.8284 2 18.2426 2.87868 19.1213C3.75736 20 5.17157 20 8 20H16C18.8284 20 20.2426 20 21.1213 19.1213C22 18.2426 22 16.8284 22 14V11.0694C22 9.13438 22 8.16685 21.5704 7.45301C21.3179 7.03348 20.9665 6.68212 20.547 6.42962C19.8332 6 18.8656 6 16.9306 6H15.6211C14.5693 6 13.6018 5.42438 13.1 4.5Z" />
      </mask>
      <g mask="url(#mask0_2_171)">
        <path fill="#57606A" d="M2.87869 19.1213L3.93935 18.0607L2.87869 19.1213ZM21.5704 7.45301L20.2852 8.22651L21.5704 7.45301ZM20.547 6.42962L19.7735 7.71481L20.547 6.42962ZM21.1213 19.1213L20.0607 18.0607L21.1213 19.1213ZM5.00001 4.5H10.5789V1.5H5.00001V4.5ZM3.50001 8V6H0.500007V8H3.50001ZM3.50001 14V8H0.500007V14H3.50001ZM16 18.5H8.00001V21.5H16V18.5ZM20.5 11.0694V14H23.5V11.0694H20.5ZM15.6211 7.5H16.9306V4.5H15.6211V7.5ZM15.6211 4.5C15.1193 4.5 14.6577 4.22537 14.4183 3.78436L11.7817 5.21564C12.5459 6.62338 14.0193 7.5 15.6211 7.5V4.5ZM0.500007 14C0.500007 15.3718 0.496821 16.5516 0.623218 17.4917C0.755416 18.475 1.05354 19.4175 1.81803 20.182L3.93935 18.0607C3.82516 17.9465 3.68394 17.7426 3.59647 17.0919C3.5032 16.3982 3.50001 15.4566 3.50001 14H0.500007ZM8.00001 18.5C6.54339 18.5 5.60183 18.4968 4.90807 18.4035C4.25746 18.3161 4.05354 18.1748 3.93935 18.0607L1.81803 20.182C2.58252 20.9465 3.52505 21.2446 4.50832 21.3768C5.44845 21.5032 6.6282 21.5 8.00001 21.5V18.5ZM23.5 11.0694C23.5 10.1305 23.5015 9.32253 23.4398 8.6633C23.3759 7.98227 23.2345 7.30907 22.8556 6.67952L20.2852 8.22651C20.3359 8.3108 20.4093 8.47827 20.4528 8.94324C20.4985 9.43 20.5 10.0733 20.5 11.0694H23.5ZM16.9306 7.5C17.9267 7.5 18.57 7.50154 19.0568 7.54716C19.5217 7.59074 19.6892 7.66408 19.7735 7.71481L21.3205 5.14444C20.6909 4.76554 20.0177 4.62408 19.3367 4.56025C18.6775 4.49846 17.8695 4.5 16.9306 4.5V7.5ZM22.8556 6.67952C22.4768 6.05022 21.9498 5.52318 21.3205 5.14444L19.7735 7.71481C19.9833 7.84106 20.1589 8.01674 20.2852 8.22651L22.8556 6.67952ZM10.5789 4.5C11.0807 4.5 11.5423 4.77463 11.7817 5.21564L14.4183 3.78436C13.6541 2.37662 12.1807 1.5 10.5789 1.5V4.5ZM16 21.5C17.3718 21.5 18.5516 21.5032 19.4917 21.3768C20.475 21.2446 21.4175 20.9465 22.182 20.182L20.0607 18.0607C19.9465 18.1748 19.7426 18.3161 19.0919 18.4035C18.3982 18.4968 17.4566 18.5 16 18.5V21.5ZM20.5 14C20.5 15.4566 20.4968 16.3982 20.4035 17.0919C20.3161 17.7426 20.1748 17.9465 20.0607 18.0607L22.182 20.182C22.9465 19.4175 23.2446 18.475 23.3768 17.4917C23.5032 16.5516 23.5 15.3718 23.5 14H20.5ZM5.00001 1.5C2.51473 1.5 0.500007 3.51472 0.500007 6H3.50001C3.50001 5.17157 4.17158 4.5 5.00001 4.5V1.5Z" />
        <path stroke="#57606A" strokeWidth="1.5" strokeLinecap="round" d="M8.75 14.25H15.25" />
      </g>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function ArrowLeft(props) {

  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" stroke="black" strokeWidth="1.0" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.82862 13.2888L3.32764 8.78784L7.82862 4.28687" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.95361 8.78821H13.0806" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Burger(props) {

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="rgba(65, 65, 67, 1)"
      width="24"
      height="24"
      style={{marginLeft: 10}}
    >
      <path
        d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function NavBurger(props) {

  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 9C5 8.44772 5.44772 8 6 8H24C24.5523 8 25 8.44772 25 9C25 9.55228 24.5523 10 24 10H6C5.44772 10 5 9.55228 5 9ZM5 15C5 14.4477 5.44772 14 6 14H24C24.5523 14 25 14.4477 25 15C25 15.5523 24.5523 16 24 16H6C5.44772 16 5 15.5523 5 15ZM6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22H24C24.5523 22 25 21.5523 25 21C25 20.4477 24.5523 20 24 20H6Z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function ArrowShort(props) {

  return (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" {...props}>
      <path d="M0.589844 10.59L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.59Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Tick(props) {

  return (
    <svg width="18" height="18" stroke="#8B949E" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M4 9L7.66667 13L15 5" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Test(props) {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.1391 10.9359C17.1751 10.6359 17.1991 10.3239 17.1991 9.9999C17.1991 9.6759 17.1751 9.3639 17.1271 9.0639L19.1551 7.4799C19.3351 7.3359 19.3831 7.0719 19.2751 6.8679L17.3551 3.5439C17.2351 3.3279 16.9831 3.2559 16.7671 3.3279L14.3791 4.2879C13.8751 3.9039 13.3471 3.5919 12.7591 3.3519L12.3991 0.807902C12.3631 0.567902 12.1591 0.399902 11.9191 0.399902H8.07913C7.83913 0.399902 7.64713 0.567902 7.61113 0.807902L7.25113 3.3519C6.66313 3.5919 6.12313 3.9159 5.63113 4.2879L3.24313 3.3279C3.02713 3.2439 2.77513 3.3279 2.65513 3.5439L0.73513 6.8679C0.61513 7.0839 0.66313 7.3359 0.85513 7.4799L2.88313 9.0639C2.83513 9.3639 2.79913 9.6879 2.79913 9.9999C2.79913 10.3119 2.82313 10.6359 2.87113 10.9359L0.84313 12.5199C0.66313 12.6639 0.61513 12.9279 0.72313 13.1319L2.64313 16.4559C2.76313 16.6719 3.01513 16.7439 3.23113 16.6719L5.61913 15.7119C6.12313 16.0959 6.65113 16.4079 7.23913 16.6479L7.59913 19.1919C7.64713 19.4319 7.83913 19.5999 8.07913 19.5999H11.9191C12.1591 19.5999 12.3631 19.4319 12.3871 19.1919L12.7471 16.6479C13.3351 16.4079 13.8751 16.0839 14.3671 15.7119L16.7551 16.6719C16.9711 16.7559 17.2231 16.6719 17.3431 16.4559L19.2631 13.1319C19.3831 12.9159 19.3351 12.6639 19.1431 12.5199L17.1391 10.9359ZM9.99913 13.5999C8.01913 13.5999 6.39913 11.9799 6.39913 9.9999C6.39913 8.0199 8.01913 6.3999 9.99913 6.3999C11.9791 6.3999 13.5991 8.0199 13.5991 9.9999C13.5991 11.9799 11.9791 13.5999 9.99913 13.5999Z" fill="#414143" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function UpdateProfile() {

  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 8.5C10.21 8.5 12 6.71 12 4.5C12 2.29 10.21 0.5 8 0.5C5.79 0.5 4 2.29 4 4.5C4 6.71 5.79 8.5 8 8.5ZM8 10.5C5.33 10.5 0 11.84 0 14.5V15.5C0 16.0523 0.447715 16.5 1 16.5H15C15.5523 16.5 16 16.0523 16 15.5V14.5C16 11.84 10.67 10.5 8 10.5Z" fill="#414143" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Back() {

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#F3E9E2" />
      <path d="M16 21.5L17.0575 20.4425L12.8725 16.25H22V14.75H12.8725L17.0575 10.5575L16 9.5L10 15.5L16 21.5Z" fill="#404043" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Poll(props) {

  return (
    <svg width="22" height="22" viewBox="0 0 24 24">
      <path
        d="M20.222 9.16h-1.334c.015-.09.028-.182.028-.277V6.57c0-.98-.797-1.777-1.778-1.777H3.5V3.358c0-.414-.336-.75-.75-.75s-.75.336-.75.75V20.83c0 .415.336.75.75.75s.75-.335.75-.75v-1.434h10.556c.98 0 1.778-.797 1.778-1.777v-2.313c0-.095-.014-.187-.028-.278h4.417c.98 0 1.778-.798 1.778-1.778v-2.31c0-.983-.797-1.78-1.778-1.78zM17.14 6.293c.152 0 .277.124.277.277v2.31c0 .154-.125.28-.278.28H3.5V6.29h13.64zm-2.807 9.014v2.312c0 .153-.125.277-.278.277H3.5v-2.868h10.556c.153 0 .277.126.277.28zM20.5 13.25c0 .153-.125.277-.278.277H3.5V10.66h16.722c.153 0 .278.124.278.277v2.313z"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function ArrowDown(props) {

  return (
    <svg viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" color="rgb(65, 65, 67)" width="12" height="12" {...props}>
      <path d="M1.41.295L6 4.875l4.59-4.58L12 1.705l-6 6-6-6L1.41.295z" />
    </svg>
  );
}

/**
 *
 *
 *
 */
export function ArrowUp(props) {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="rgb(65, 65, 67)" {...props}>
      <path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z" />
    </svg>
  );
}

/**
 *
 *
 *
 */
export function Phone(props) {

  return (
    <S.Svg style={{ transform: 'scale(1.2)' }} height="24" width="24" fill={'white'} viewBox="0 0 32 32" {...props}>
      <path
        d="M16 11.175l.009 4.091c1.077 0 4.431.265 4.431.835s-.08 2.52.159 2.876c.635.953 2.879 2.563 4.12 2.579 1.88.024 5.048-2.909 4.565-4.939-.704-2.955-8.02-5.949-13.285-5.949v.005c-5.265 0-12.579 2.989-13.283 5.944-.483 2.029 2.685 4.963 4.565 4.939 1.241-.016 3.485-1.625 4.12-2.579.239-.356.159-2.307.159-2.876s3.369-.836 4.447-.836l-.005-4.089z"
      />
    </S.Svg>
  );
}


/**
 *
 *
 *
 */
export function PhoneUp(props) {

  return (
    <S.Svg style={{ transform: 'rotate(225deg) scale(1.2)' }} fill={'white'} height="24" width="24" viewBox="0 0 32 32" {...props}>
      <path
        d="M16 11.175l.009 4.091c1.077 0 4.431.265 4.431.835s-.08 2.52.159 2.876c.635.953 2.879 2.563 4.12 2.579 1.88.024 5.048-2.909 4.565-4.939-.704-2.955-8.02-5.949-13.285-5.949v.005c-5.265 0-12.579 2.989-13.283 5.944-.483 2.029 2.685 4.963 4.565 4.939 1.241-.016 3.485-1.625 4.12-2.579.239-.356.159-2.307.159-2.876s3.369-.836 4.447-.836l-.005-4.089z"
      />
    </S.Svg>
  );
}


/**
 *
 *
 *
 */
export function Group(props) {

  return (
    <svg viewBox="0 0 212 212" width="50" height="50" {...props}>
      <path
        fill="#FFF"
        d="M61.543 100.988c8.073 0 14.246-6.174 14.246-14.246s-6.173-14.246-14.246-14.246-14.246 6.173-14.246 14.246 6.174 14.246 14.246 14.246zm8.159 17.541a48.192 48.192 0 0 1 8.545-6.062c-4.174-2.217-9.641-3.859-16.704-3.859-21.844 0-28.492 15.67-28.492 15.67v8.073h26.181l.105-.248c.303-.713 3.164-7.151 10.365-13.574zm80.755-9.921c-6.854 0-12.21 1.543-16.336 3.661a48.223 48.223 0 0 1 8.903 6.26c7.201 6.422 10.061 12.861 10.364 13.574l.105.248h25.456v-8.073c-.001 0-6.649-15.67-28.492-15.67zm0-7.62c8.073 0 14.246-6.174 14.246-14.246s-6.173-14.246-14.246-14.246-14.246 6.173-14.246 14.246 6.173 14.246 14.246 14.246zm-44.093 3.21a23.21 23.21 0 0 0 4.464-.428c.717-.14 1.419-.315 2.106-.521 1.03-.309 2.023-.69 2.976-1.138a21.099 21.099 0 0 0 3.574-2.133 20.872 20.872 0 0 0 5.515-6.091 21.283 21.283 0 0 0 2.121-4.823 22.16 22.16 0 0 0 .706-3.193c.16-1.097.242-2.224.242-3.377s-.083-2.281-.242-3.377a22.778 22.778 0 0 0-.706-3.193 21.283 21.283 0 0 0-3.272-6.55 20.848 20.848 0 0 0-4.364-4.364 21.099 21.099 0 0 0-3.574-2.133 21.488 21.488 0 0 0-2.976-1.138 22.33 22.33 0 0 0-2.106-.521 23.202 23.202 0 0 0-4.464-.428c-12.299 0-21.705 9.405-21.705 21.704 0 12.299 9.406 21.704 21.705 21.704zM145.629 131a36.739 36.739 0 0 0-1.2-1.718 39.804 39.804 0 0 0-3.367-3.967 41.481 41.481 0 0 0-3.442-3.179 42.078 42.078 0 0 0-5.931-4.083 43.725 43.725 0 0 0-3.476-1.776c-.036-.016-.069-.034-.104-.05-5.692-2.581-12.849-4.376-21.746-4.376-8.898 0-16.055 1.795-21.746 4.376-.196.089-.379.185-.572.276a43.316 43.316 0 0 0-3.62 1.917 42.32 42.32 0 0 0-5.318 3.716 41.501 41.501 0 0 0-3.443 3.179 40.632 40.632 0 0 0-3.366 3.967c-.452.61-.851 1.186-1.2 1.718-.324.493-.6.943-.841 1.351l-.061.101a27.96 27.96 0 0 0-.622 1.119c-.325.621-.475.975-.475.975v11.692h82.53v-11.692s-.36-.842-1.158-2.195a35.417 35.417 0 0 0-.842-1.351z"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function BlueTick(props) {

  return (
    <svg fill="none" viewBox="0 0 20 16" color="rgba(6, 189, 182, 1)" width="16" height="16" {...props}>
      <path
        fill="currentColor"
        d="M6.923 10.058a1 1 0 01-1.414 0L3.285 7.833a1 1 0 00-1.413-.001L.71 8.988a1 1 0 00-.001 1.416l4.8 4.8a1 1 0 001.414 0l11.929-11.93a1 1 0 000-1.413L17.698.707a1 1 0 00-1.414 0l-9.361 9.351z"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function ProfilePlus(props) {

  return (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" {...props}>
      <path
        strokeWidth={1}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C16.21 8 18 6.21 18 4C18 1.79 16.21 0 14 0C11.79 0 10 1.79 10 4C10 6.21 11.79 8 14 8ZM14 10C11.33 10 6 11.34 6 14V15C6 15.5523 6.44772 16 7 16H21C21.5523 16 22 15.5523 22 15V14C22 11.34 16.67 10 14 10ZM5 10C5 10.5523 4.55228 11 4 11C3.44772 11 3 10.5523 3 10V8H1C0.447715 8 0 7.55228 0 7C0 6.44772 0.447715 6 1 6H3V4C3 3.44772 3.44772 3 4 3C4.55228 3 5 3.44772 5 4V6H7C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8H5V10Z"
        fill="currentColor"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Coffee(props) {

  return (
    <svg width="50" height="50" viewBox="0 0 511.988 511.988" {...props}>
      <path d="M394.655,202.654H95.988c-17.643,0-32,14.357-32,32v21.333c0,76.117,42.048,145.152,109.717,180.16c5.227,2.688,11.669,0.661,14.379-4.587c2.688-5.227,0.661-11.669-4.587-14.379c-60.544-31.317-98.176-93.077-98.176-161.195v-21.333c0-5.888,4.779-10.667,10.667-10.667h298.667c5.888,0,10.667,4.779,10.667,10.667v21.333c0,68.117-37.632,129.877-98.197,161.173c-5.248,2.709-7.275,9.152-4.587,14.379c1.899,3.669,5.632,5.781,9.493,5.781c1.664,0,3.328-0.384,4.885-1.195c67.691-34.987,109.739-104,109.739-180.139v-21.333C426.655,217.011,412.297,202.654,394.655,202.654z" />
      <path d="M489.865,422.558c-1.664-3.989-5.547-6.592-9.856-6.592H10.676c-4.309,0-8.192,2.603-9.856,6.592c-1.664,3.989-0.747,8.576,2.304,11.627l23.915,23.936c14.123,14.101,32.853,21.867,52.8,21.867h330.965c19.947,0,38.699-7.765,52.843-21.867l23.915-23.936C490.612,431.134,491.529,426.547,489.865,422.558z M448.543,443.038c-10.069,10.069-23.488,15.616-37.717,15.616H79.839c-14.229,0-27.648-5.547-37.717-15.616l-5.717-5.717H454.26L448.543,443.038z" />
      <path d="M491.359,253.022c-28.736-18.475-74.645,1.579-79.787,3.904c-5.355,2.453-7.744,8.768-5.291,14.144c2.453,5.376,8.747,7.744,14.144,5.291c10.283-4.672,43.264-15.744,59.392-5.355c7.275,4.672,10.837,13.739,10.837,27.648c0,42.709-86.144,68.523-119.403,74.88l-7.552,1.493c-5.781,1.131-9.536,6.741-8.405,12.523c1.003,5.077,5.461,8.597,10.453,8.597c0.683,0,1.365-0.064,2.069-0.213l7.488-1.472c5.589-1.067,136.683-26.773,136.683-95.808C511.988,277.193,505.034,261.854,491.359,253.022z" />
      <path d="M328.372,113.31c17.344-21.675,17.344-55.616,0-77.291c-3.691-4.608-10.368-5.376-14.997-1.664c-4.608,3.691-5.355,10.389-1.664,14.997c10.987,13.717,10.987,36.907-0.021,50.667c-17.365,21.675-17.365,55.616,0,77.291c2.112,2.645,5.205,4.011,8.341,4.011c2.325,0,4.693-0.768,6.656-2.347c4.608-3.691,5.355-10.411,1.664-14.997C317.343,150.259,317.343,127.07,328.372,113.31z" />
      <path d="M264.287,113.31c17.365-21.675,17.365-55.616,0-77.291c-3.669-4.608-10.389-5.355-14.997-1.664c-4.608,3.691-5.355,10.411-1.664,14.997c11.008,13.717,11.008,36.907-0.021,50.667c-17.344,21.675-17.344,55.616,0,77.291c2.112,2.645,5.205,4.011,8.341,4.011c2.325,0,4.672-0.768,6.656-2.347c4.608-3.691,5.355-10.389,1.664-14.997C253.279,150.259,253.279,127.07,264.287,113.31z" />
      <path d="M200.372,113.331c17.344-21.675,17.344-55.616,0-77.291c-3.669-4.608-10.368-5.376-14.997-1.664c-4.587,3.669-5.333,10.389-1.664,14.976c10.987,13.717,10.987,36.907-0.021,50.667c-17.365,21.675-17.365,55.616,0,77.291c2.112,2.645,5.205,4.011,8.341,4.011c2.325,0,4.693-0.768,6.656-2.325c4.608-3.691,5.355-10.411,1.664-14.997C189.343,150.259,189.343,127.091,200.372,113.331z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Schema(props) {

  const { stroke, ...rest } = props;

  return (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_83_4175)">
        <path d="M3.8 4.20001H8.2" stroke={stroke ?? '#8B949E'} strokeWidth="1.0" strokeLinecap="round" />
        <path fill={stroke ?? '#8B949E'} d="M6.4 1.2H8.8C10.3424 1.2 11.3785 1.20255 12.1514 1.30646C12.8897 1.40572 13.2057 1.57728 13.4142 1.78578C13.6227 1.9943 13.7942 2.31029 13.8935 3.04862C13.9566 3.51746 13.9823 4.08316 13.9928 4.8H15.193C15.1643 2.81634 15.0172 1.69173 14.2627 0.937256C13.3255 -9.53674e-08 11.817 0 8.8 0H6.4C3.38301 0 1.87452 -9.53674e-08 0.937256 0.937256C9.53674e-08 1.87452 0 3.38301 0 6.4C0 9.41696 9.53674e-08 10.9255 0.937256 11.8627C1.87452 12.8 3.38301 12.8 6.4 12.8H8.8C11.817 12.8 13.3255 12.8 14.2627 11.8627C15.0172 11.1082 15.1643 9.98368 15.193 8H13.9928C13.9823 8.7168 13.9566 9.28256 13.8935 9.75136C13.7942 10.4897 13.6227 10.8057 13.4142 11.0142C13.2057 11.2227 12.8897 11.3942 12.1514 11.4935C11.3785 11.5974 10.3424 11.6 8.8 11.6H6.4C4.85758 11.6 3.82149 11.5974 3.04862 11.4935C2.31029 11.3942 1.9943 11.2227 1.78578 11.0142C1.57728 10.8057 1.40572 10.4897 1.30646 9.75136C1.20255 8.97848 1.2 7.9424 1.2 6.4C1.2 4.8576 1.20255 3.82149 1.30646 3.04862C1.40572 2.31029 1.57728 1.9943 1.78578 1.78578C1.9943 1.57728 2.31029 1.40572 3.04862 1.30646C3.82149 1.20255 4.85758 1.2 6.4 1.2Z" />
        <path stroke={stroke ?? '#8B949E'} strokeWidth="1.0" d="M13.6 4.60001H12.8C11.8059 4.60001 11 5.40589 11 6.40001C11 7.39412 11.8059 8.20001 12.8 8.20001H13.6C14.5941 8.20001 15.4 7.39412 15.4 6.40001C15.4 5.40589 14.5941 4.60001 13.6 4.60001Z" />
      </g>
      <defs>
        <clipPath id="clip0_83_4175">
          <rect width="16.6" height="12.8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Vector(props) {

  return (
    <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        // d="M1 1.5L5 5.5L1 9.5"
        d="M1 1L5 5.5L1 10"
        stroke="#57606A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Stats(props) {

  return (
    <svg width="18" height="19" viewBox="0 0 18 19" stroke="#8B949E" strokeWidth="1.2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.1667 1.79163H4.83341C2.87741 1.79163 1.29175 3.37728 1.29175 5.33329V13.6666C1.29175 15.6226 2.87741 17.2083 4.83341 17.2083H13.1667C15.1228 17.2083 16.7084 15.6226 16.7084 13.6666V5.33329C16.7084 3.37728 15.1228 1.79163 13.1667 1.79163Z" />
      <path d="M5.875 9.29163V13.0416" strokeLinecap="round" />
      <path d="M9.20825 5.95837V13.0417" strokeLinecap="round" />
      <path d="M12.5417 8.45837V13.0417" strokeLinecap="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Settings(props) {

  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" stroke="#57606A" strokeWidth="1.0" style={{transform: 'scale(1.1)'}} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M1.93344 5.67309L2.52011 4.65695C2.86678 4.05651 3.64419 3.84332 4.25041 4.19332C5.29541 4.79665 6.14932 4.30431 6.14726 3.09453C6.14704 2.40159 6.71605 1.82942 7.41472 1.83253L8.74359 1.83762C9.35632 1.8296 9.85192 2.33126 9.85992 2.94403L9.86012 3.09039C9.85639 4.29683 10.7109 4.79017 11.7596 4.18706L11.8864 4.11403C12.4211 3.81459 13.1033 3.99293 13.4028 4.52762L14.0716 5.67587C14.4237 6.27942 14.2127 7.05825 13.6124 7.40453C12.5637 8.00767 12.5643 8.99333 13.6093 9.59667C14.2097 9.94333 14.4229 10.7207 14.0729 11.3269L13.4863 12.3431C13.1396 12.9435 12.3621 13.1567 11.7559 12.8067C10.7109 12.2034 9.85698 12.6957 9.85905 13.9055C9.85598 14.6042 9.29032 15.1706 8.59158 15.1675L7.26279 15.1624C6.65001 15.1705 6.15444 14.6688 6.14642 14.056L6.14624 13.9097C6.14996 12.7032 5.29548 12.2099 4.24676 12.813L4.11992 12.886C3.58523 13.1855 2.903 13.0071 2.60356 12.4724L1.93474 11.3242C1.58268 10.7206 1.79371 9.9418 2.39393 9.59547C3.44265 8.9924 3.44208 8.00673 2.39708 7.4034C1.79086 7.05339 1.58678 6.27353 1.93344 5.67309Z" />
      <path d="M10.1666 8.50004C10.1666 7.30342 9.19654 6.33337 7.99992 6.33337C6.8033 6.33337 5.83325 7.30342 5.83325 8.50004C5.83325 9.69666 6.8033 10.6667 7.99992 10.6667C9.19654 10.6667 10.1666 9.69666 10.1666 8.50004Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Pipe(props) {

  return (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#57606A" {...props}>
      <path d="M0.833252 9.0507V6.26362C0.833252 3.50839 0.833252 2.13077 1.71694 1.66049C2.60063 1.19022 3.74325 1.95977 6.02859 3.49885L8.19625 4.95872C10.1342 6.26378 11.1031 6.91637 11.0833 7.82637C11.0637 8.73645 10.0673 9.34637 8.07484 10.5664L5.90709 11.8935C3.6605 13.269 2.53726 13.9567 1.68525 13.4793C0.833252 13.0019 0.833252 11.6849 0.833252 9.0507Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Query(props) {

  return (
    <React.Fragment>
      <Vector transform={`rotate(180)`} style={{ marginRight: 2 }} />
      <Vector />
    </React.Fragment>
  );
}


/**
 *
 *
 *
 */
export function GreenTick(props) {

  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.9375 9.5C15.9375 5.66852 12.8315 2.5625 9 2.5625C5.16852 2.5625 2.0625 5.66852 2.0625 9.5C2.0625 13.3315 5.16852 16.4375 9 16.4375C12.8315 16.4375 15.9375 13.3315 15.9375 9.5Z" fill="#2DA44E" stroke="#2DA44E" strokeWidth="1.5" />
      <path d="M6 9.5L8.25 11.75L12.75 7.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function CrossTick(props) {

  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.9375 9.5C15.9375 5.66852 12.8315 2.5625 9 2.5625C5.16852 2.5625 2.0625 5.66852 2.0625 9.5C2.0625 13.3315 5.16852 16.4375 9 16.4375C12.8315 16.4375 15.9375 13.3315 15.9375 9.5Z" fill="#EF233C" stroke="#EF233C" strokeWidth="1.5" />
      <path d="M12 6.5L6 12.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 12.5L6 6.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function WarnTick(props) {

  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.9375 9.5C15.9375 5.66852 12.8315 2.5625 9 2.5625C5.16852 2.5625 2.0625 5.66852 2.0625 9.5C2.0625 13.3315 5.16852 16.4375 9 16.4375C12.8315 16.4375 15.9375 13.3315 15.9375 9.5Z" fill="#FD8C73" stroke="#FD8C73" strokeWidth="1.5" />
      <path d="M12 6.5L6 12.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Draft(props) {

  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path stroke="#8B949E" strokeWidth="1" d="M12.75 2.5625H5.25C3.48959 2.5625 2.0625 3.98959 2.0625 5.75V13.25C2.0625 15.0104 3.48959 16.4375 5.25 16.4375H12.75C14.5104 16.4375 15.9375 15.0104 15.9375 13.25V5.75C15.9375 3.98959 14.5104 2.5625 12.75 2.5625Z" />
      <mask id="mask0_363_1641" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="1" y="9" width="16" height="8">
        <path fill="#8B949E" fillRule="evenodd" clipRule="evenodd" d="M7.21858 10.625C7.05329 9.9638 6.45922 9.5 5.77771 9.5H4.49982C3.04987 9.5 2.32489 9.5 1.88147 9.96605C1.43804 10.4322 1.47241 11.1215 1.54115 12.5002C1.62316 14.1452 1.8679 15.1713 2.59816 15.9016C3.69652 17 5.46428 17 8.9998 17C12.5354 17 14.3031 17 15.4014 15.9016C16.1317 15.1713 16.3764 14.1452 16.4585 12.5002C16.5273 11.1215 16.5616 10.4322 16.1181 9.96605C15.6747 9.5 14.9498 9.5 13.4998 9.5H12.222C11.5404 9.5 10.9464 9.9638 10.7811 10.625C10.6158 11.2862 10.0218 11.75 9.34023 11.75H8.65945C7.97793 11.75 7.38388 11.2862 7.21858 10.625Z" />
      </mask>
      <g mask="url(#mask0_363_1641)">
        <path fill="#8B949E" d="M16.4585 12.5002L15.335 12.4442L16.4585 12.5002ZM1.88154 9.96606L1.06647 9.19064L1.88154 9.96606ZM4.49988 10.625H5.77777V8.37501H4.49988V10.625ZM3.39372 15.1062C2.98443 14.6968 2.74525 14.0574 2.66482 12.4442L0.417613 12.5563C0.501213 14.233 0.751495 15.6459 1.80273 16.6972L3.39372 15.1062ZM8.99987 15.875C7.20031 15.875 5.96381 15.8726 5.03502 15.7477C4.13859 15.6272 3.69903 15.4115 3.39372 15.1062L1.80273 16.6972C2.59578 17.4902 3.58928 17.8236 4.73521 17.9777C5.84877 18.1274 7.26392 18.125 8.99987 18.125V15.875ZM14.606 15.1062C14.3007 15.4115 13.8611 15.6272 12.9647 15.7477C12.0359 15.8726 10.7994 15.875 8.99987 15.875V18.125C10.7358 18.125 12.151 18.1274 13.2645 17.9777C14.4105 17.8236 15.404 17.4902 16.197 16.6972L14.606 15.1062ZM15.335 12.4442C15.2545 14.0574 15.0153 14.6968 14.606 15.1062L16.197 16.6972C17.2483 15.6459 17.4986 14.233 17.5821 12.5563L15.335 12.4442ZM12.222 10.625H13.4999V8.37501H12.222V10.625ZM9.34029 10.625H8.65952V12.875H9.34029V10.625ZM8.65952 10.625C8.49422 10.625 8.35014 10.5125 8.31009 10.3522L6.12723 10.8979C6.41773 12.0598 7.46177 12.875 8.65952 12.875V10.625ZM9.68972 10.3522C9.64967 10.5125 9.50559 10.625 9.34029 10.625V12.875C10.538 12.875 11.582 12.0598 11.8726 10.8979L9.68972 10.3522ZM12.222 8.37501C11.0243 8.37501 9.98027 9.19019 9.68972 10.3522L11.8726 10.8979C11.9126 10.7375 12.0567 10.625 12.222 10.625V8.37501ZM5.77777 10.625C5.94306 10.625 6.08715 10.7375 6.12723 10.8979L8.31009 10.3522C8.01954 9.19019 6.97551 8.37501 5.77777 8.37501V10.625ZM17.5821 12.5563C17.6148 11.901 17.6482 11.2879 17.6004 10.7846C17.5485 10.2376 17.3905 9.67124 16.9333 9.19064L15.3032 10.7416C15.3072 10.7458 15.3102 10.7479 15.3174 10.7669C15.3281 10.7947 15.3476 10.8608 15.3605 10.9972C15.3892 11.2999 15.371 11.7208 15.335 12.4442L17.5821 12.5563ZM13.4999 10.625C14.2579 10.625 14.7089 10.6276 15.0311 10.6725C15.1784 10.693 15.251 10.7171 15.2829 10.7308C15.2903 10.7339 15.2951 10.7363 15.2978 10.7378C15.3005 10.7393 15.3017 10.7401 15.302 10.7403C15.3021 10.7404 15.3019 10.7402 15.3017 10.7401C15.3014 10.7398 15.3019 10.7402 15.3032 10.7416L16.9333 9.19064C16.4677 8.70126 15.8912 8.52066 15.3419 8.44401C14.8282 8.37246 14.1918 8.37501 13.4999 8.37501V10.625ZM4.49988 8.37501C3.80796 8.37501 3.17157 8.37246 2.65793 8.44401C2.10852 8.52066 1.53207 8.70126 1.06647 9.19064L2.6966 10.7416C2.69784 10.7402 2.69829 10.7398 2.69808 10.7401C2.69786 10.7402 2.69768 10.7404 2.69782 10.7403C2.69798 10.7401 2.6992 10.7393 2.70192 10.7378C2.70468 10.7363 2.70948 10.7339 2.71688 10.7308C2.74873 10.7171 2.82132 10.693 2.96859 10.6725C3.29079 10.6276 3.74186 10.625 4.49988 10.625V8.37501ZM2.66482 12.4442C2.62875 11.7208 2.61055 11.2999 2.63928 10.9972C2.65223 10.8608 2.67165 10.7947 2.68231 10.7669C2.68956 10.7479 2.69253 10.7458 2.6966 10.7416L1.06647 9.19064C0.609289 9.67124 0.45127 10.2376 0.399348 10.7846C0.351589 11.2879 0.384941 11.901 0.417613 12.5563L2.66482 12.4442Z" />
      </g>
    </svg>
  );
}

/**
 *
 *
 *
 */
export function Pen(props) {

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="#8B949E" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path strokeWidth="1.1" strokeLinecap="round" d="M8.25 15.75H15.75" />
      <path strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" fillRule="evenodd" clipRule="evenodd" d="M12.6634 3.61783C11.6366 2.71787 10.0681 2.81206 9.15915 3.82874C9.15915 3.82874 4.64165 8.88142 3.07514 10.6352C1.50656 12.388 2.65637 14.8095 2.65637 14.8095C2.65637 14.8095 5.2455 15.6214 6.79029 13.8932C8.3361 12.1649 12.8764 7.08764 12.8764 7.08764C13.7853 6.07096 13.6892 4.51779 12.6634 3.61783Z" />
      <path strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" d="M7.77026 5.4693L11.1941 8.45935" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Table(props) {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'scale(0.95)', paddingTop: 2 }} {...props}>
      <path stroke="#57606A" strokeWidth="1.5" d="M8 2.75H5C3.75736 2.75 2.75 3.75736 2.75 5V8C2.75 9.24264 3.75736 10.25 5 10.25H8C9.24264 10.25 10.25 9.24264 10.25 8V5C10.25 3.75736 9.24264 2.75 8 2.75Z" />
      <path stroke="#57606A" strokeWidth="1.5" d="M19 2.75H16C14.7574 2.75 13.75 3.75736 13.75 5V8C13.75 9.24264 14.7574 10.25 16 10.25H19C20.2426 10.25 21.25 9.24264 21.25 8V5C21.25 3.75736 20.2426 2.75 19 2.75Z" />
      <path stroke="#57606A" strokeWidth="1.5" d="M19 13.75H16C14.7574 13.75 13.75 14.7574 13.75 16V19C13.75 20.2426 14.7574 21.25 16 21.25H19C20.2426 21.25 21.25 20.2426 21.25 19V16C21.25 14.7574 20.2426 13.75 19 13.75Z" />
      <path stroke="#57606A" strokeWidth="1.5" d="M8 13.75H5C3.75736 13.75 2.75 14.7574 2.75 16V19C2.75 20.2426 3.75736 21.25 5 21.25H8C9.24264 21.25 10.25 20.2426 10.25 19V16C10.25 14.7574 9.24264 13.75 8 13.75Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Bulb(props) {

  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      stroke="#8B949E"
      fill="#8B949E"
      strokeWidth="0.2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 2.5c-3.81 0-6.5 2.743-6.5 6.119 0 1.536.632 2.572 1.425 3.56.172.215.347.422.527.635l.096.112c.21.25.427.508.63.774.404.531.783 1.128.995 1.834a.75.75 0 0 1-1.436.432c-.138-.46-.397-.89-.753-1.357a18.111 18.111 0 0 0-.582-.714l-.092-.11c-.18-.212-.37-.436-.555-.667C4.87 12.016 4 10.651 4 8.618 4 4.363 7.415 1 12 1s8 3.362 8 7.619c0 2.032-.87 3.397-1.755 4.5-.185.23-.375.454-.555.667l-.092.109c-.21.248-.405.481-.582.714-.356.467-.615.898-.753 1.357a.751.751 0 0 1-1.437-.432c.213-.706.592-1.303.997-1.834.202-.266.419-.524.63-.774l.095-.112c.18-.213.355-.42.527-.634.793-.99 1.425-2.025 1.425-3.561C18.5 5.243 15.81 2.5 12 2.5ZM8.75 18h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5Zm.75 3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function DirPlus() {

  return (
    <S.PlusContainer>
      <Dir style={{transform: 'scale(0.9)'}}/>
      <S.PlusInner>
        <Plus color={'#FD8C73'} stroke={'#FD8C73'} style={{ stroke: '#FD8C73' }} />
      </S.PlusInner>
    </S.PlusContainer>
  );
}


/**
 *
 *
 *
 */
export function Rocket(props) {

  return (
    <svg
      stroke="#8B949E"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M461.81 53.81a4.4 4.4 0 0 0-3.3-3.39c-54.38-13.3-180 34.09-248.13 102.17a294.9 294.9 0 0 0-33.09 39.08c-21-1.9-42-.3-59.88 7.5-50.49 22.2-65.18 80.18-69.28 105.07a9 9 0 0 0 9.8 10.4l81.07-8.9a180.29 180.29 0 0 0 1.1 18.3 18.15 18.15 0 0 0 5.3 11.09l31.39 31.39a18.15 18.15 0 0 0 11.1 5.3 179.91 179.91 0 0 0 18.19 1.1l-8.89 81a9 9 0 0 0 10.39 9.79c24.9-4 83-18.69 105.07-69.17 7.8-17.9 9.4-38.79 7.6-59.69a293.91 293.91 0 0 0 39.19-33.09c68.38-68 115.47-190.86 102.37-247.95zM298.66 213.67a42.7 42.7 0 1 1 60.38 0 42.65 42.65 0 0 1-60.38 0z"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M109.64 352a45.06 45.06 0 0 0-26.35 12.84C65.67 382.52 64 448 64 448s65.52-1.67 83.15-19.31A44.73 44.73 0 0 0 160 402.32"
      />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function MapPlus() {

  return (
    <S.PlusContainer>
      <Map style={{ transform: 'scale(1.2)' }} />
      <S.PlusInner>
        <Plus color={'#FD8C73'} />
      </S.PlusInner>
    </S.PlusContainer>
  );
}


/**
 *
 *
 *
 */
export function TablePlus() {

  return (
    <S.PlusContainer>
      <DatabaseTable style={{ transform: 'scale(0.9)' }} />
      <S.PlusInner style={{bottom: -3.5, right: -3.5}}>
        <Plus color={'#FD8C73'} />
      </S.PlusInner>
    </S.PlusContainer>
  );
}


/**
 *
 *
 *
 */
export function Cog(props) {

  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="black" d="M14.469 7.80052L13.6538 7.66924C13.6012 7.66038 13.5528 7.63491 13.5157 7.59655C13.4785 7.5582 13.4547 7.50897 13.4475 7.45607C13.4319 7.35605 13.4163 7.25572 13.3944 7.15882C13.3838 7.1068 13.3899 7.05276 13.4118 7.0044C13.4337 6.95603 13.4702 6.91579 13.5163 6.88939L14.238 6.48867C14.2927 6.46074 14.3352 6.41381 14.3576 6.35671C14.3801 6.2996 14.3809 6.23627 14.3599 6.17861L14.2349 5.83478C14.214 5.77696 14.1724 5.72897 14.1181 5.7001C14.0638 5.67122 14.0007 5.66353 13.9411 5.6785L13.1318 5.83478C13.0792 5.84497 13.0247 5.83798 12.9764 5.81485C12.9281 5.79172 12.8884 5.75367 12.8633 5.70632C12.8165 5.6188 12.7665 5.53117 12.7133 5.44345C12.6853 5.39783 12.6723 5.34454 12.6762 5.29113C12.6801 5.23772 12.7008 5.1869 12.7352 5.14588L13.2756 4.52262C13.3175 4.47802 13.3416 4.41961 13.3434 4.35843C13.3451 4.29725 13.3243 4.23756 13.285 4.19067L13.0509 3.90936C13.0119 3.86205 12.9566 3.831 12.8959 3.82227C12.8352 3.81354 12.7735 3.82776 12.7227 3.86216L12.0135 4.28819C11.9679 4.31521 11.9149 4.32705 11.8621 4.32199C11.8094 4.31693 11.7596 4.29525 11.72 4.26006C11.645 4.19411 11.5668 4.12847 11.4887 4.06565C11.4471 4.03262 11.4171 3.98723 11.4031 3.93604C11.389 3.88484 11.3916 3.83051 11.4105 3.7809L11.7043 3.00729C11.7294 2.95116 11.7328 2.8878 11.7141 2.82928C11.6953 2.77077 11.6557 2.7212 11.6028 2.69003L11.2839 2.50531C11.2307 2.47509 11.1683 2.46544 11.1084 2.47817C11.0486 2.4909 10.9955 2.52513 10.9592 2.57438L10.4391 3.22578C10.41 3.26677 10.368 3.29678 10.3198 3.31096C10.2716 3.32514 10.22 3.32266 10.1734 3.30392C10.1734 3.30392 9.99835 3.23203 9.86707 3.18795C9.81672 3.17117 9.77301 3.13881 9.74228 3.09554C9.71154 3.05227 9.69536 3.00035 9.6961 2.94728L9.7086 2.12053C9.71228 2.05904 9.69333 1.99833 9.65533 1.94985C9.61733 1.90136 9.5629 1.86846 9.5023 1.85735L9.14004 1.79484C9.0794 1.78434 9.01701 1.79637 8.96462 1.82866C8.91223 1.86096 8.87346 1.91129 8.8556 1.97019L8.58679 2.75317C8.56955 2.80364 8.53661 2.84727 8.49281 2.8777C8.449 2.90812 8.39662 2.92374 8.3433 2.92227H8.03699C7.98375 2.9234 7.93152 2.90764 7.88778 2.87727C7.84404 2.84689 7.81104 2.80345 7.7935 2.75317L7.52469 1.97019C7.50683 1.91129 7.46806 1.86096 7.41567 1.82866C7.36328 1.79637 7.30089 1.78434 7.24025 1.79484L6.87798 1.85735C6.81739 1.86846 6.76296 1.90136 6.72496 1.94985C6.68695 1.99833 6.66801 2.05904 6.67169 2.12053L6.68419 2.94728C6.68495 3.00048 6.66871 3.05253 6.63785 3.09587C6.60699 3.13921 6.56311 3.17158 6.51259 3.18827C6.4407 3.2164 6.28442 3.2761 6.2094 3.30423C6.12188 3.33549 6.01873 3.31048 5.93434 3.21327L5.41829 2.57751C5.38181 2.52846 5.32862 2.49448 5.26878 2.48198C5.20894 2.46948 5.1466 2.47934 5.09353 2.50968L4.77471 2.69441C4.72163 2.72498 4.68173 2.7741 4.66268 2.83233C4.64364 2.89055 4.6468 2.95376 4.67157 3.00979L4.96538 3.7834C4.98397 3.83305 4.98643 3.88729 4.9724 3.93842C4.95837 3.98955 4.92857 4.03494 4.88724 4.06815C4.8091 4.13066 4.73095 4.19661 4.65594 4.26256C4.61631 4.29775 4.56653 4.31943 4.51377 4.32449C4.46102 4.32955 4.40803 4.31771 4.36244 4.29069L3.66353 3.8581C3.6125 3.82452 3.55095 3.81079 3.49049 3.81948C3.43002 3.82818 3.37484 3.8587 3.33534 3.9053L3.10122 4.18661C3.06189 4.2335 3.04113 4.29319 3.04285 4.35436C3.04458 4.41554 3.06869 4.47396 3.1106 4.51856L3.65103 5.14182C3.68617 5.18248 3.70727 5.23338 3.71121 5.28698C3.71516 5.34058 3.70172 5.39402 3.67291 5.43938C3.61977 5.52273 3.56976 5.61036 3.52288 5.70225C3.49739 5.74924 3.45769 5.78697 3.40947 5.81004C3.36125 5.83311 3.30696 5.84035 3.25438 5.83072L2.44514 5.67443C2.38552 5.65989 2.32264 5.66778 2.26846 5.6966C2.21428 5.72542 2.17259 5.77315 2.15133 5.83072L2.0263 6.17454C2.00532 6.2322 2.00613 6.29554 2.02858 6.35264C2.05103 6.40975 2.09357 6.45668 2.1482 6.48461L2.86899 6.88564C2.91552 6.91152 2.9525 6.95169 2.97445 7.00021C2.9964 7.04873 3.00216 7.10302 2.99089 7.15507C2.97213 7.25509 2.95338 7.3523 2.93775 7.45232C2.93025 7.50507 2.90625 7.5541 2.8692 7.59239C2.83215 7.63068 2.78393 7.65626 2.73146 7.66549L1.91628 7.79677C1.85562 7.80425 1.79971 7.83344 1.75891 7.87895C1.71811 7.92446 1.69518 7.98321 1.69435 8.04433V8.41066C1.6936 8.47222 1.71598 8.53183 1.75708 8.57767C1.79818 8.62352 1.855 8.65226 1.91628 8.65821L2.73146 8.78949C2.78409 8.79835 2.83251 8.82382 2.86963 8.86218C2.90675 8.90054 2.93062 8.94976 2.93775 9.00266C2.95338 9.10268 2.96901 9.20302 2.99089 9.29991C3.00146 9.35194 2.99538 9.40597 2.9735 9.45434C2.95161 9.5027 2.91504 9.54295 2.86899 9.56935L2.14727 9.97068C2.09264 9.99862 2.05009 10.0455 2.02764 10.1027C2.00519 10.1598 2.00438 10.2231 2.02536 10.2808L2.15039 10.6246C2.17131 10.6824 2.21294 10.7304 2.26722 10.7593C2.3215 10.7881 2.38457 10.7958 2.44421 10.7809L3.25344 10.6246C3.30606 10.6144 3.36055 10.6214 3.40889 10.6445C3.45723 10.6676 3.49686 10.7057 3.52194 10.753C3.56883 10.8406 3.61884 10.9282 3.67197 11.0159C3.70003 11.0615 3.71301 11.1148 3.70908 11.1682C3.70516 11.2216 3.68452 11.2725 3.65009 11.3135L3.10966 11.9374C3.06775 11.982 3.04364 12.0404 3.04192 12.1016C3.04019 12.1627 3.06096 12.2224 3.10029 12.2693L3.3344 12.5506C3.37341 12.5979 3.42867 12.629 3.48937 12.6377C3.55006 12.6464 3.61183 12.6322 3.6626 12.5978L4.37181 12.1718C4.4174 12.1448 4.4704 12.1329 4.52315 12.138C4.5759 12.143 4.62569 12.1647 4.66531 12.1999C4.74033 12.2659 4.81847 12.3315 4.89661 12.3943C4.93818 12.4274 4.96815 12.4728 4.9822 12.5239C4.99625 12.5751 4.99364 12.6295 4.97476 12.6791L4.68094 13.4527C4.65634 13.5089 4.65325 13.5722 4.67227 13.6305C4.69129 13.6888 4.73109 13.7381 4.78409 13.769L5.10291 13.9537C5.15612 13.984 5.21856 13.9936 5.27841 13.9809C5.33826 13.9681 5.39136 13.9339 5.42767 13.8847L5.95247 13.2395C6.01811 13.1583 6.12438 13.1239 6.20878 13.1583C6.31505 13.202 6.38694 13.227 6.51822 13.2711C6.56874 13.2878 6.61262 13.3201 6.64348 13.3635C6.67434 13.4068 6.69057 13.4589 6.68982 13.5121L6.67731 14.3388C6.67363 14.4003 6.69258 14.461 6.73058 14.5095C6.76859 14.558 6.82302 14.5909 6.88361 14.602L7.24588 14.6645C7.30652 14.675 7.36891 14.663 7.42129 14.6307C7.47368 14.5984 7.51246 14.5481 7.53031 14.4892L7.79912 13.7077C7.81637 13.6573 7.8493 13.6136 7.89311 13.5832C7.93691 13.5528 7.9893 13.5372 8.04261 13.5386H8.34893C8.40217 13.5375 8.4544 13.5533 8.49814 13.5837C8.54187 13.614 8.57488 13.6575 8.59242 13.7077L8.86123 14.4892C8.87909 14.5481 8.91786 14.5984 8.97025 14.6307C9.02264 14.663 9.08502 14.675 9.14567 14.6645L9.50793 14.602C9.56852 14.5909 9.62295 14.558 9.66096 14.5095C9.69896 14.461 9.71791 14.4003 9.71423 14.3388L9.70172 13.5121C9.70097 13.4589 9.7172 13.4068 9.74806 13.3635C9.77892 13.3201 9.8228 13.2878 9.87332 13.2711C10.0046 13.227 10.0921 13.1926 10.1734 13.1614C10.2547 13.1301 10.3547 13.1301 10.4328 13.227L10.9642 13.8815C11.0007 13.931 11.0541 13.9652 11.1142 13.9778C11.1743 13.9903 11.237 13.9803 11.2902 13.9497L11.609 13.7649C11.6624 13.7344 11.7025 13.6851 11.7215 13.6267C11.7406 13.5682 11.7373 13.5048 11.7122 13.4486L11.4183 12.675C11.3998 12.6253 11.3973 12.571 11.4114 12.5199C11.4254 12.4687 11.4552 12.4232 11.4965 12.39C11.5746 12.3274 11.6528 12.2618 11.7278 12.1959C11.7674 12.1607 11.8172 12.139 11.87 12.1339C11.9227 12.1289 11.9757 12.1407 12.0213 12.1677L12.728 12.595C12.779 12.6286 12.8406 12.6423 12.9011 12.6336C12.9615 12.6249 13.0167 12.5944 13.0562 12.5478L13.2903 12.2665C13.3296 12.2196 13.3504 12.1599 13.3487 12.0987C13.347 12.0376 13.3229 11.9791 13.2809 11.9345L12.7405 11.3113C12.7054 11.2706 12.6843 11.2197 12.6803 11.1661C12.6764 11.1125 12.6898 11.0591 12.7186 11.0137C12.7718 10.9293 12.8218 10.8417 12.8687 10.7509C12.8942 10.7039 12.9338 10.6661 12.9821 10.6431C13.0303 10.62 13.0846 10.6128 13.1372 10.6224L13.9464 10.7787C14.006 10.7932 14.0689 10.7853 14.1231 10.7565C14.1773 10.7277 14.2189 10.68 14.2402 10.6224L14.3652 10.2786C14.3862 10.2209 14.3854 10.1576 14.363 10.1005C14.3405 10.0434 14.298 9.99643 14.2433 9.9685L13.5216 9.56778C13.4751 9.54189 13.4381 9.50172 13.4162 9.45321C13.3942 9.40469 13.3884 9.35039 13.3997 9.29835C13.4185 9.19833 13.4372 9.10112 13.4529 9.0011C13.4604 8.94835 13.4844 8.89932 13.5214 8.86103C13.5585 8.82274 13.6067 8.79715 13.6591 8.78793L14.4743 8.65665C14.535 8.64917 14.5909 8.61998 14.6317 8.57447C14.6725 8.52896 14.6954 8.47021 14.6962 8.40909V8.04214C14.6928 7.98157 14.6682 7.92414 14.6266 7.87995C14.5851 7.83576 14.5293 7.80763 14.469 7.80052ZM8.19577 3.7287C9.19411 3.72827 10.1642 4.06019 10.953 4.6721C11.7418 5.28401 12.3045 6.14109 12.5523 7.10818C12.5708 7.18193 12.5722 7.25892 12.5564 7.33328C12.5406 7.40764 12.5081 7.47743 12.4613 7.53733C12.4145 7.59724 12.3546 7.64569 12.2863 7.679C12.218 7.71231 12.1429 7.72961 12.0669 7.72957H8.77746C8.68911 7.72958 8.60234 7.70619 8.52597 7.66177C8.4496 7.61735 8.38635 7.5535 8.34268 7.4767L6.7142 4.61014C6.67628 4.5435 6.65419 4.46903 6.64964 4.39248C6.64509 4.31594 6.6582 4.23938 6.68796 4.16872C6.71772 4.09805 6.76333 4.03517 6.82126 3.98494C6.8792 3.93472 6.94791 3.89848 7.02208 3.87904C7.40519 3.77853 7.79969 3.72799 8.19577 3.7287ZM3.69479 8.22968C3.69423 7.62701 3.8147 7.03037 4.04907 6.47514C4.28344 5.91991 4.62692 5.4174 5.05915 4.99741C5.11373 4.94338 5.18002 4.90264 5.25288 4.87836C5.32574 4.85408 5.40321 4.84691 5.4793 4.85739C5.55538 4.86788 5.62802 4.89575 5.69159 4.93884C5.75517 4.98194 5.80796 5.03909 5.84588 5.10587L7.47874 7.97962C7.52188 8.05517 7.54457 8.14065 7.54457 8.22765C7.54457 8.31464 7.52188 8.40013 7.47874 8.47567L5.83244 11.3419C5.79422 11.4085 5.74119 11.4654 5.67744 11.5082C5.61369 11.551 5.54095 11.5785 5.46484 11.5887C5.38874 11.5989 5.31132 11.5913 5.23858 11.5668C5.16584 11.5422 5.09974 11.5012 5.0454 11.4469C4.61738 11.0276 4.27743 10.527 4.0455 9.97457C3.81357 9.4221 3.69434 8.82886 3.69479 8.22968ZM8.19577 12.7307C7.79281 12.7317 7.39146 12.6797 7.00207 12.5759C6.92792 12.5562 6.8593 12.5197 6.80152 12.4692C6.74373 12.4188 6.69834 12.3557 6.66885 12.2848C6.63935 12.214 6.62655 12.1373 6.63144 12.0608C6.63632 11.9842 6.65875 11.9098 6.69701 11.8433L8.34049 8.98172C8.38445 8.90558 8.44769 8.84238 8.52386 8.79848C8.60003 8.75458 8.68642 8.73153 8.77433 8.73166H12.0685C12.1445 8.73167 12.2195 8.749 12.2878 8.78233C12.3561 8.81567 12.4159 8.86412 12.4626 8.92402C12.5094 8.98392 12.5419 9.05369 12.5576 9.12803C12.5734 9.20237 12.572 9.27932 12.5536 9.35305C12.3053 10.3199 11.7422 11.1767 10.9532 11.7883C10.1642 12.3998 9.19405 12.7314 8.19577 12.7307Z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Smile(props) {

  return (
    <svg
      stroke="#8B949E"
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
      <path d="M9 9l.01 0"></path>
      <path d="M15 9l.01 0"></path>
      <path d="M8 13a4 4 0 1 0 8 0h-8"></path>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function ArrowRightAlt(props) {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none" {...props}>
      <path fill="inherit" d="M5.93013 9.03919C6.14167 9.25072 6.48463 9.25072 6.69617 9.03919L10.3524 5.38294C10.3561 5.37922 10.3598 5.37545 10.3634 5.37163L10.3635 5.37148C10.41 5.32229 10.4454 5.26653 10.4699 5.20731C10.4964 5.14351 10.511 5.07356 10.5111 5.0002C10.5111 5.0001 10.5111 5.00001 10.5111 4.99992C10.5111 4.99973 10.5111 4.99955 10.5111 4.99936C10.511 4.92604 10.4964 4.85612 10.4699 4.79236C10.4437 4.72916 10.405 4.66991 10.3539 4.61838C10.3533 4.61782 10.3528 4.61727 10.3522 4.61671L6.69617 0.960653L6.68471 0.949523C6.47243 0.749185 6.13789 0.752896 5.93013 0.960653L5.919 0.972109C5.71867 1.18439 5.72238 1.51893 5.93013 1.72669L8.6617 4.45825H1.0319L1.01747 4.45844C0.724986 4.46609 0.490234 4.70559 0.490234 4.99992C0.490234 5.29907 0.732746 5.54159 1.0319 5.54159H8.6617L5.93013 8.27316L5.919 8.28461C5.71867 8.4969 5.72238 8.83143 5.93013 9.03919Z"/>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Compass(props) {
  return (
    <svg
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#8B949E"
      fill="#8B949E"
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit="10"
        strokeWidth="32"
        d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
      />
      <path d="m350.67 150.93-117.2 46.88a64 64 0 0 0-35.66 35.66l-46.88 117.2a8 8 0 0 0 10.4 10.4l117.2-46.88a64 64 0 0 0 35.66-35.66l46.88-117.2a8 8 0 0 0-10.4-10.4zM256 280a24 24 0 1 1 24-24 24 24 0 0 1-24 24z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Dollar(props) {
  return (
    <svg
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 288 512"
      height="12px"
      width="12px"
      stroke="#8B949E"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"></path>
    </svg>
  );
}


/**
 *
 *
 *
 */
export function Pound(props) {
  return (
    <svg
      stroke="#8B949E"
      fill="#8B949E"
      strokeWidth="0"
      viewBox="0 0 1024 1024"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" />
    </svg>
  );
}

/**
 *
 *
 *
 */
export function ChevronDown(props) {
  return (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
    </svg>
  );
}


/**
 *
 *
 *
 */
const S = {};

S.Svg = styled.svg`
  ${p => `transform: ${p.grow ? `scale(${p.grow})` : ''}`}
`;

S.PlusContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  svg { stroke-width: 0 !important; }
`;

S.PlusInner = styled.div`
  position: absolute;
  bottom: -2px;
  right: -4px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  overflow: hidden;
`;